// import React, { useEffect, useState, useRef } from "react";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";
// import Marquee from "react-fast-marquee";
// import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";
// import { NavLink } from "react-router-dom";
// import 'bootstrap-icons/font/bootstrap-icons.css';
// import { AiOutlinePlus, AiOutlineArrowRight } from "react-icons/ai";
// import { FcAdvertising } from "react-icons/fc";
// import { Autoplay } from "swiper";
// import {
//   FaCode,
//   FaMobileAlt,
//   FaDatabase,
//   FaCloud,
//   FaDesktop,
//   FaChartBar,
//   FaUniversity,
//   FaMoneyBillWave,
//   FaBriefcase,
//   FaUtensils,
//   FaPlane,
//   FaTruck,
//   FaGem,
//   FaTint,
//   FaSeedling,
//   FaCog,
//   FaCalendarAlt,
// } from "react-icons/fa";
// import Slider from "../../components/slider/Slider";
// import { motion, useScroll, useTransform, useInView } from "framer-motion";
// import IndustriesSection from "../../components/Industries";

// // Custom hook for intersection observer
// const useIntersectionObserver = (options = {}) => {
//   const [isIntersecting, setIsIntersecting] = useState(false);
//   const ref = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(([entry]) => {
//       setIsIntersecting(entry.isIntersecting);
//     }, {
//       threshold: 0.1,
//       rootMargin: '-50px',
//       ...options
//     });

//     if (ref.current) {
//       observer.observe(ref.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return [ref, isIntersecting];
// };

// // Animation variants (only for sections that keep effects)
// const fadeInUp = {
//   hidden: { opacity: 0, y: 60 },
//   visible: { 
//     opacity: 1, 
//     y: 0,
//     transition: { duration: 0.8, ease: "easeOut" }
//   }
// };

// const staggerContainer = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.2,
//       delayChildren: 0.1
//     }
//   }
// };

// const slideInLeft = {
//   hidden: { opacity: 0, x: -60 },
//   visible: { 
//     opacity: 1, 
//     x: 0,
//     transition: { duration: 0.8, ease: "easeOut" }
//   }
// };

// const slideInRight = {
//   hidden: { opacity: 0, x: 60 },
//   visible: { 
//     opacity: 1, 
//     x: 0,
//     transition: { duration: 0.8, ease: "easeOut" }
//   }
// };

// const scaleIn = {
//   hidden: { opacity: 0, scale: 0.8 },
//   visible: { 
//     opacity: 1, 
//     scale: 1,
//     transition: { duration: 0.6, ease: "easeOut" }
//   }
// };

// const Home = () => {
//   const [hoveredId, setHoveredId] = useState(null);
//   const [stats, setStats] = useState({
//     projects: 0,
//     clients: 0,
//     years: 0,
//     solutions: 0,
//   });
//   const [activeTab, setActiveTab] = useState("interns");

//   // Scroll-based animations (only for sections that keep effects)
//   const { scrollYProgress } = useScroll();
//   const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
//   const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

//   // Refs for intersection observer (only for sections that keep effects)
//   const [aboutRef, aboutInView] = useIntersectionObserver();
//   const [statsRef, statsInView] = useIntersectionObserver();
//   const [testimonialsRef, testimonialsInView] = useIntersectionObserver();

//   // Simulated counter animation
//   useEffect(() => {
//     if (statsInView) {
//       const finalStats = { projects: 50, clients: 40, years: 3, solutions: 2 };
//       const duration = 2000;
//       const frameDuration = 20;
//       const totalFrames = duration / frameDuration;
//       let frame = 0;

//       const timer = setInterval(() => {
//         frame++;
//         const progress = frame / totalFrames;

//         setStats({
//           projects: Math.floor(progress * finalStats.projects),
//           clients: Math.floor(progress * finalStats.clients),
//           years: Math.floor(progress * finalStats.years),
//           solutions: Math.floor(progress * finalStats.solutions),
//         });

//         if (frame === totalFrames) {
//           clearInterval(timer);
//           setStats(finalStats);
//         }
//       }, frameDuration);

//       return () => clearInterval(timer);
//     }
//   }, [statsInView]);

//   // Employee data
//   const employees = [
//     {
//       id: 1,
//       name: "Gauri Birari",
//       position: "React Js Developer",
//       initials: "GB",
//       quote: "Reflecting on my journey, I am working as a front-end web developer at Innovative Solutions. It's already been a year since I joined here. When I joined here, I started from scratch, but now after 1 year, I am thrilled to be learning outside of my field here. I am pleased to have the chance to create a project from scratch.",
//     },
//     {
//       id: 2,
//       name: "Sakshi Kadave",
//       position: "Node Js Developer",
//       initials: "SK",
//       quote: "I am working as a backend end developer at the Innovative Solutions, and I have been with this company for 1 year now. My experience with this company has been like my second home. All the people around me in the company, especially My Senior sir, who raised me up in all things that I even had no idea about before.",
//     },
//   ];

//   // Intern testimonials
//   const interns = [
//     {
//       id: 1,
//       name: "Gaurav Bhambere",
//       position: "React Native Developer Intern",
//       initials: "GB",
//       quote: "As an app developer at Innovative Solutions, I've had the privilege to contribute to some groundbreaking projects. My journey here has been incredibly rewarding, thanks to the supportive team and inspiring leadership. The collaborative environment fosters creativity and innovation, allowing me to push the boundaries of app development.",
//     },
//     {
//       id: 2,
//       name: "Harshal Deore",
//       position: "React Js Developer Intern",
//       initials: "HD",
//       quote: "I am grateful for the opportunity to work as a React JS Developer Intern at The Innovative Solutions, Nashik. Over the past six months, I have gained valuable hands-on experience in web development while working on impactful projects such as the NMC Law Department Case Management System and testing the NMC Garden website.",
//     },
//     {
//       id: 3,
//       name: "Shivam Kapdia",
//       position: "Node Js Developer Intern",
//       initials: "SK",
//       quote: "My internship at Innovative Solutions, Nashik, as a Node.js Developer was an incredibly enriching experience that significantly enhanced my technical and professional skills. Under the guidance of My Senior, I gained hands-on expertise in developing backend solutions using Node.js and handling APIs, which deepened my understanding of server-side programming and data management.",
//     },
//     {
//       id: 4,
//       name: "Gaurav Lonari",
//       position: "Node Js Developer Intern",
//       initials: "GL",
//       quote: "I have been working as a Full Stack Developer Intern at The Innovative Solutions for almost 3 months now and I wanted to share my positive experience. The onboarding process, led by Mr. Nilesh was smooth and made it easy for me to contribute to the company's objectives.",
//     },
//     {
//       id: 5,
//       name: "Kunjal Pande",
//       position: "Front Web Developer Intern",
//       initials: "KP",
//       quote: "My name is Kunjal and I had the opportunity to go through a three-month Web Development internship at Innovative Solutions. I must say this was an enriching experience for me as an intern. Since I got this opportunity, my goal was to learn as much as possible about web development.",
//     },
//     {
//       id: 6,
//       name: "Mansi Mahajan",
//       position: "Backend Web Developer Intern",
//       initials: "MM",
//       quote: "I am very glad to tell you about my internship experience at The Innovative Solutions company. It was a great experience of learning and practical implementation of a live project. I learned many skills like leadership skills, team management, time management, etc while leading my Goda project team.",
//     },
//     {
//       id: 7,
//       name: "Nisha Bagade",
//       position: "Backend Web Developer Intern",
//       initials: "NB",
//       quote: "My Name is Nisha Sitaram Bagade I am from sanghavi college of engineering Nashik during the internship in innovative solutions Nashik is very good The internship was innovative and mind enlarging. Rather than teach us everything, we were made to reason out the why behind things . I enjoyed the internship days with sakshi mam and gauri mam both girls are non IT field still they do thier best that very inspiring.",
//     },
//     {
//       id: 8,
//       name: "Manish Karegaonkar",
//       position: "Frontend Web Developer Intern",
//       initials: "MK",
//       quote: "I am very glad to tell you about my internship experience at The Innovative Solutions company. It was a great experience of learning and practical implementation of a live project.Currently, I am working as a Full stack web developer intern for the last 3 months got a lot of practical coding experience. I learned many skills like leadership skills, team management, time management, etc while leading my Goda project team.",
//     },
//       {
//       id: 9,
//       name: "Omkar Shinde",
//       position: "Backend Developer Intern",
//       initials: "OS",
//       quote: "As a Backend Developer Intern at Innovative Solutions, I gained hands-on experience in building and deploying Node.js APIs. This opportunity allowed me to strengthen my backend development skills while contributing to real-world projects in a collaborative environment.",
//     },
//       {
//       id: 10,
//       name: "Sarthak Lolge",
//       position: "Frontend Web Developer Intern",
//       initials: "SL",
//       quote: "I completed an internship in React and React Native at Innovative Solutions. During this experience, I worked on developing user-friendly interfaces and building efficient, responsive applications. This internship helped me enhance my skills in front-end development and mobile app design, and I’m excited to continue learning and contributing to innovative projects.",
//     },
//   ];

//   const currentTestimonials = activeTab === "employees" ? employees : interns;
//   const handleTabChange = (tab) => setActiveTab(tab);

//   // Technology Stack
//   const technologies = [
//     {
//       name: "HTML",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
//       color: "#E34F26",
//     },
//     {
//       name: "CSS",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
//       color: "#1572B6",
//     },
//     {
//       name: "Javascript",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
//       color: "#F7DF1E",
//     },
//     {
//       name: "React JS",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
//       color: "#61DAFB",
//     },
//     {
//       name: "React Native",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
//       color: "#61DAFB",
//     },
//     {
//       name: "Node JS",
//       icon: "/languages/node.png",
//       color: "#47A248",
//     },
//     {
//       name: "PHP",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg",
//       color: "#777BB4",
//     },
//     {
//       name: "Spring Boot",
//       icon: "/languages/spring.png",
//       color: "#777BB4",
//     },
//     {
//       name: "Java",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
//       color: "#007396",
//     },
//     {
//       name: "MySQL",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
//       color: "#4479A1",
//     },
//     {
//       name: "MongoDB",
//       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
//       color: "#47A248",
//     },
//     {
//       name: "Figma",
//       icon: "/languages/figma.png",
//       color: "#47A248",
//     },
//      {
//       name: "Flutter",
//       icon: "/languages/flutter.png",
//       color: "#47A248",
//     },
//       {
//       name: "Angular",
//       icon: "/languages/angular.png",
//       color: "#47A248",
//     },
//       {
//       name: "PostgreSQL",
//       icon: "/languages/postgresql.png",
//       color: "#47A248",
//     },
//       {
//       name: ".Net",
//       icon: "/languages/net.png",
//       color: "#47A248",
//     },
//       {
//       name: "Power BI",
//       icon: "/languages/power_bi.png",
//       color: "#47A248",
//     },
//       {
//       name: "Tableau",
//       icon: "/languages/tableau.png",
//       color: "#47A248",
//     },
//   ];

//   const serviceData = [
//     {
//       id: 1,
//       img: "webd.png",
//       title: "Website Design and Development",
//       subtitle: "Frontend & Backend Solutions",
//       desc: "Crafting responsive, high-performance websites and applications that drive business growth and enhance user experience.",
//       icon: "bi-code-slash",
//     },
//     {
//       id: 2,
//       img: "digital.jpg",
//       title: "Digital Marketing and SEO",
//       subtitle: "Data-Driven Strategies",
//       desc: "Strategic campaigns that increase your online visibility, engage your target audience, and convert visitors into loyal customers.",
//       icon: "bi-graph-up-arrow",
//     },
//     {
//       id: 3,
//       img: "consultancy.jpg",
//       title: "Business Consultancy",
//       subtitle: "Expert IT Guidance",
//       desc: "Strategic advisory services to help you navigate the digital landscape, optimize operations, and accelerate business growth.",
//       icon: "bi-briefcase",
//     },
//     {
//       id: 4,
//       img: "cyber.jpg",
//       title: "Cyber Security Training",
//       subtitle: "Advanced Protection",
//       desc: "Comprehensive security solutions that safeguard your digital assets, protect sensitive data, and prevent cyber threats.",
//       icon: "bi-shield-lock",
//     },
//     {
//       id: 5,
//       img: "software.jpg",
//       title: "Custom Software Development",
//       subtitle: "Custom Enterprise Solutions",
//       desc: "Tailored software solutions designed to address your unique business challenges and drive operational efficiency.",
//       icon: "bi-cpu",
//     },
//     {
//       id: 6,
//       img: "android.jpg",
//       title: "Mobile App Development",
//       subtitle: "iOS & Android Apps",
//       desc: "Intuitive, feature-rich mobile applications that deliver exceptional user experiences across all devices and platforms.",
//       icon: "bi-phone",
//     },
//     {
//       id: 7,
//       img: "android.jpg",
//       title: "Hosting Services",
//       subtitle: "Cpanel Dynamic Hosting",
//       desc: "Reliable, scalable hosting solutions with 99.9% uptime guarantee and comprehensive technical support for your digital presence.",
//       icon: "bi-hdd-stack",
//     },
//     {
//       id: 8,
//       img: "android.jpg",
//       title: "VAPT Audit Services",
//       subtitle: "Vulnerability Assessment",
//       desc: "Comprehensive security audits to identify vulnerabilities and strengthen your digital infrastructure against cyber threats.",
//       icon: "bi-shield-check",
//     },
//   ];

//   return (
//     <>
//       {/* Parallax Hero Section - KEEPS EFFECTS */}
//       <motion.div 
//         className="hero-parallax"
//         style={{ y, opacity }}
//       >
//         <Slider />
//       </motion.div>

//       {/* About Section - KEEPS EFFECTS */}
//       <motion.div 
//         ref={aboutRef}
//         className="container my-2 py-3"
//         initial="hidden"
//         animate={aboutInView ? "visible" : "hidden"}
//         variants={staggerContainer}
//       >
//         <div className="row align-items-center">
//           <motion.div className="col-md-6" variants={slideInLeft}>
//             <div className="about-image-container position-relative overflow-hidden rounded">
//               <motion.img
//                 className="img-fluid rounded shadow"
//                 src="/images/6316.jpg"
//                 alt="About Us"
//                 whileHover={{ scale: 1.05 }}
//                 transition={{ duration: 0.3 }}
//               />
//               <div className="image-overlay"></div>
//             </div>
//           </motion.div>
//           <motion.div className="col-md-6 mt-4 mt-md-5" variants={slideInRight}>
//             <div className="mb-4">
//               <motion.h6 
//                 className="text-primary fw-bold"
//                 variants={fadeInUp}
//               >
//                 ABOUT US
//               </motion.h6>
//               <motion.h2 
//                 className="display-6 fw-bold mb-3"
//                 variants={fadeInUp}
//               >
//                 Welcome to The Innovative Solutions -
//                 <span style={{ color: "#0f679d" }}>
//                   Your Partner in Innovative IT Solutions!
//                 </span>
//               </motion.h2>
//             </div>
//             <motion.p 
//               className="text-muted mb-4"
//               variants={fadeInUp}
//             >
//               At The Innovative Solutions, we are a dynamic IT solutions company
//               dedicated to providing a diverse range of services. Our primary
//               goal is to deliver cutting-edge solutions to our esteemed
//               customers, always striving to exceed expectations in an innovative
//               way. We understand that in today's fast-paced and ever-evolving
//               technological landscape, businesses need adaptable and advanced IT
//               solutions to stay ahead of the competition. Therefore, we take
//               pride in offering customer-centric services that are faster,
//               authentic, and tailored to meet the unique needs of each client.
//             </motion.p>
//             <motion.button 
//               className="btn btn-primary px-4"
//               variants={scaleIn}
//               whileHover={{ scale: 1.05, boxShadow: "0 8px 25px rgba(13,110,253,0.3)" }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <NavLink to="/about" className="text-decoration-none text-white">
//                 Learn More About Us
//               </NavLink>
//             </motion.button>
//           </motion.div>
//         </div>
//       </motion.div>

//       {/* Services Section - EFFECTS REMOVED */}
//       <div className="container py-3">
//         <div className="mb-4">
//           <h1 className="text-primary text-center fw-bold">Our Services</h1>
//           <p className="text-center">
//             Empowering businesses with cutting-edge technology to solve complex
//             challenges and drive sustainable growth.
//           </p>
//         </div>
//         <div className="row g-4">
//           {serviceData.map((service) => (
//             <div key={service.id} className="col-lg-4 col-md-6">
//               <div
//                 className="service-card h-100 p-0 rounded-4 overflow-hidden border-0"
//                 style={{
//                   background: hoveredId === service.id ? "#243e7c" : "#ffffff",
//                   boxShadow:
//                     hoveredId === service.id
//                       ? "0 15px 30px rgba(13,110,253,0.2)"
//                       : "0 10px 30px rgba(0,0,0,0.05)",
//                   transition: "all 0.4s ease",
//                 }}
//                 onMouseEnter={() => setHoveredId(service.id)}
//                 onMouseLeave={() => setHoveredId(null)}
//               >
//                 <div className="card-body p-4 p-lg-5">
//                   <div
//                     className="service-icon mb-4 d-inline-flex align-items-center justify-content-center rounded-circle"
//                     style={{
//                       width: "65px",
//                       height: "65px",
//                       background:
//                         hoveredId === service.id
//                           ? "rgba(255,255,255,0.2)"
//                           : "rgba(13,110,253,0.1)",
//                       transition: "all 0.4s ease",
//                     }}
//                   >
//                     <i
//                       className={`${service.icon} fs-3 ${
//                         hoveredId === service.id ? "text-white" : "text-primary"
//                       }`}
//                     ></i>
//                   </div>

//                   <span
//                     className={`badge mb-2 ${
//                       hoveredId === service.id
//                         ? "bg-white text-primary"
//                         : "bg-light text-primary"
//                     }`}
//                   >
//                     {service.subtitle}
//                   </span>

//                   <h3
//                     className={`h4 fw-bold mb-3 ${
//                       hoveredId === service.id ? "text-white" : ""
//                     }`}
//                   >
//                     {service.title}
//                   </h3>

//                   <p
//                     className={
//                       hoveredId === service.id
//                         ? "text-white mb-4"
//                         : "text-secondary mb-4"
//                     }
//                   >
//                     {service.desc}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Stats Section - KEEPS EFFECTS */}
//       <motion.section
//         ref={statsRef}
//         className="stats-section py-5 border-bottom position-relative overflow-hidden"
//         style={{
//           background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//           color: "#fff",
//         }}
//         initial="hidden"
//         animate={statsInView ? "visible" : "hidden"}
//         variants={staggerContainer}
//       >
//         {/* Animated background particles */}
//         <div className="stats-bg-animation">
//           {[...Array(20)].map((_, i) => (
//             <motion.div
//               key={i}
//               className="particle"
//               animate={{
//                 y: [0, -100, 0],
//                 opacity: [0, 1, 0],
//               }}
//               transition={{
//                 duration: 3 + Math.random() * 2,
//                 repeat: Infinity,
//                 delay: Math.random() * 2,
//               }}
//               style={{
//                 position: 'absolute',
//                 left: `${Math.random() * 100}%`,
//                 top: '100%',
//                 width: '4px',
//                 height: '4px',
//                 background: 'rgba(255,255,255,0.3)',
//                 borderRadius: '50%',
//               }}
//             />
//           ))}
//         </div>

//         <div className="container position-relative">
//           <div className="row text-center">
//             {[
//               { value: stats.projects, label: "Projects Completed", suffix: "+" },
//               { value: stats.clients, label: "Satisfied Clients", suffix: "+" },
//               { value: stats.years, label: "Years Experience", suffix: "+" },
//               { value: stats.solutions, label: "Core Solutions", suffix: "+" },
//             ].map((stat, index) => (
//               <motion.div
//                 key={index}
//                 className="col-6 col-md-3 py-4"
//                 variants={fadeInUp}
//                 custom={index}
//               >
//                 <motion.h3 
//                   className="display-4 fw-bold text-white mb-0"
//                   initial={{ scale: 0 }}
//                   animate={statsInView ? { scale: 1 } : { scale: 0 }}
//                   transition={{ delay: index * 0.2, duration: 0.8, type: "spring" }}
//                 >
//                   {stat.value}{stat.suffix}
//                 </motion.h3>
//                 <p className="text-uppercase fw-semibold text-white mb-0">
//                   {stat.label}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </motion.section>

//       {/* Technology Stack Section - EFFECTS REMOVED */}
//       <div
//         className="py-5"
//         style={{ background: "linear-gradient(135deg, #f8f9fa, #e9ecef)" }}
//       >
//         <div className="container py-5">
//           <div className="text-center mb-5">
//             <h6 className="text-primary fw-bold">OUR TECH STACK</h6>
//             <h2 className="display-5 fw-bold">Driving Excellence with</h2>
//             <h2 className="display-6 fw-bold">Proven Technology Stack</h2>
//           </div>

//           <div className="row g-4">
//             {technologies.map((tech, index) => (
//               <div key={index} className="col-6 col-sm-4 col-md-2">
//                 <div className="card h-100 border-0 shadow-sm hover-shadow transition-all">
//                   <div className="card-body d-flex flex-column align-items-center justify-content-center p-3">
//                     <img
//                       src={tech.icon}
//                       alt={tech.name}
//                       style={{
//                         height: "60px",
//                         width: "60px",
//                         marginBottom: "12px",
//                       }}
//                     />
//                     <h6 className="mb-0 text-center">{tech.name}</h6>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <IndustriesSection />

//       {/* How We Work Section - EFFECTS REMOVED */}
//       <section className="how-we-work py-5 bg-light">
//         <div className="container py-5">
//           <div className="row mb-5">
//             <div className="col-lg-6 mx-auto text-center">
//               <div className="d-flex align-items-center justify-content-center mb-2">
//                 <div
//                   style={{ width: "30px", height: "2px" }}
//                   className="bg-primary me-3"
//                 ></div>
//                 <span className="text-uppercase fw-bold text-primary">
//                   Our Approach
//                 </span>
//                 <div
//                   style={{ width: "30px", height: "2px" }}
//                   className="bg-primary ms-3"
//                 ></div>
//               </div>
//               <h2 className="display-6 fw-bold mb-4">
//                 How We Deliver Excellence
//               </h2>
//               <p className="lead text-secondary">
//                 Our proven methodology ensures your project is completed on
//                 time, within budget, and exceeds expectations.
//               </p>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-12">
//               <div className="position-relative">
//                 {/* Static connecting line */}
//                 <div
//                   className="position-absolute d-none d-lg-block"
//                   style={{
//                     top: "105px",
//                     left: "15%",
//                     right: "15%",
//                     height: "4px",
//                     background: "#e9ecef",
//                     zIndex: 0,
//                   }}
//                 ></div>

//                 <div className="row position-relative" style={{ zIndex: 1 }}>
//                   {[
//                     {
//                       title: "Discovery",
//                       icon: "bi-search",
//                       desc: "We learn about your business, goals, and challenges to establish a clear vision.",
//                     },
//                     {
//                       title: "Strategy",
//                       icon: "bi-lightbulb",
//                       desc: "Our experts develop a comprehensive plan tailored to your specific requirements.",
//                     },
//                     {
//                       title: "Design",
//                       icon: "bi-bezier",
//                       desc: "We create intuitive interfaces and architectures optimized for performance.",
//                     },
//                     {
//                       title: "Development",
//                       icon: "bi-code-square",
//                       desc: "Our engineers build robust solutions using industry-leading technologies.",
//                     },
//                     {
//                       title: "Testing",
//                       icon: "bi-bug",
//                       desc: "Rigorous quality assurance ensures your solution performs flawlessly.",
//                     },
//                     {
//                       title: "Launch",
//                       icon: "bi-rocket-takeoff",
//                       desc: "We deploy your solution and provide comprehensive training and support.",
//                     },
//                   ].map((step, index) => (
//                     <div key={index} className="col-lg-2 col-md-4 col-6 mb-4">
//                       <div className="process-item text-center">
//                         <div
//                           className="process-icon mx-auto mb-3 bg-white rounded-circle d-flex align-items-center justify-content-center"
//                           style={{
//                             width: "100px",
//                             height: "100px",
//                             boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
//                             position: "relative",
//                             zIndex: 2,
//                           }}
//                         >
//                           <div
//                             className="inner-circle rounded-circle d-flex align-items-center justify-content-center"
//                             style={{
//                               width: "70px",
//                               height: "70px",
//                               backgroundColor: "#248ecb",
//                             }}
//                           >
//                             <i className={`${step.icon} fs-3 text-white`}></i>
//                           </div>
//                         </div>
//                         <div
//                           className="badge px-3 py-2 mb-2"
//                           style={{ backgroundColor: "#243e7c" }}
//                         >
//                           Step {index + 1}
//                         </div>
//                         <h4 className="fw-bold h5 mb-2">{step.title}</h4>
//                         <p className="text-secondary small mb-0">{step.desc}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action Section - KEEPS EFFECTS */}
//       <motion.div
//         className="py-5 position-relative overflow-hidden"
//         style={{
//           background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//           color: "#fff",
//         }}
//         initial="hidden"
//         whileInView="visible"
//         variants={staggerContainer}
//         viewport={{ once: true }}
//       >
//         {/* Animated background elements */}
//         <div className="cta-bg-animation">
//           {[...Array(15)].map((_, i) => (
//             <motion.div
//               key={i}
//               className="floating-element"
//               animate={{
//                 x: [0, 30, 0],
//                 y: [0, -20, 0],
//                 rotate: [0, 180, 360],
//               }}
//               transition={{
//                 duration: 4 + Math.random() * 2,
//                 repeat: Infinity,
//                 delay: Math.random() * 2,
//               }}
//               style={{
//                 position: 'absolute',
//                 left: `${Math.random() * 100}%`,
//                 top: `${Math.random() * 100}%`,
//                 width: `${8 + Math.random() * 12}px`,
//                 height: `${8 + Math.random() * 12}px`,
//                 background: 'rgba(255,255,255,0.1)',
//                 borderRadius: '50%',
//               }}
//             />
//           ))}
//         </div>

//         <div className="container py-5 position-relative">
//           <div className="row align-items-center">
//             <motion.div className="col-lg-8 mb-4 mb-lg-0" variants={slideInLeft}>
//               <h2 className="display-6 fw-bold">
//                 Ready to Transform Your Business?
//               </h2>
//               <p className="lead mb-0">
//                 Let's discuss how our innovative solutions can help your
//                 business grow.
//               </p>
//             </motion.div>
//             <motion.div className="col-lg-4 text-lg-end" variants={slideInRight}>
//               <motion.button 
//                 className="btn btn-light btn-lg px-4"
//                 whileHover={{ 
//                   scale: 1.05, 
//                   boxShadow: "0 10px 30px rgba(255,255,255,0.3)",
//                   y: -5
//                 }}
//                 whileTap={{ scale: 0.95 }}
//                 transition={{ duration: 0.2 }}
//               >
//                 <NavLink
//                   className="text-decoration-none text-dark"
//                   to="/contact"
//                 >
//                   Contact Us Today
//                 </NavLink>
//               </motion.button>
//             </motion.div>
//           </div>
//         </div>
//       </motion.div>

//       {/* Clients Section - KEEPS EFFECTS */}
//       <motion.div 
//         className="container my-5 py-5"
//         initial="hidden"
//         whileInView="visible"
//         variants={staggerContainer}
//         viewport={{ once: true }}
//       >
//         <motion.div className="text-center mb-5" variants={fadeInUp}>
//           <h6 className="text-primary fw-bold">OUR CLIENTS</h6>
//           <h2 className="display-5 fw-bold">With Whom We Work</h2>
//           <p className="lead text-muted mx-auto" style={{ maxWidth: "700px" }}>
//             Trusted by industry leaders and innovative businesses across various
//             sectors.
//           </p>
//         </motion.div>

//         <motion.div variants={fadeInUp}>
//           <Marquee pauseOnHover speed={50} gradient={true} gradientColor={[248, 249, 250]}>
//             {[
//               { src: "/logos/mvp.png", alt: "MVP Client" },
//               { src: "/logos/auto.png", alt: "Auto Client" },
//               { src: "/logos/amc.jpeg", alt: "AMC Client" },
//               { src: "/logos/cki.jpeg", alt: "CKI Client" },
//               { src: "/logos/logo.png", alt: "Client Logo" },
//               { src: "/logos/logo1.png", alt: "Client Logo 1" },
//               { src: "/logos/sapkal.jpg", alt: "Sapkal Client" },
//               { src: "/logos/nmc.png", alt: "NMC Client" },
//               { src: "/logos/nc.png", alt: "NC Client" },
//               { src: "/logos/dhule.png", alt: "DMC Client" },
//                { src: "/logos/sambhajinagar.jpeg", alt: "CSMC Client" },
//                 { src: "/logos/thane.jpg", alt: "TMC Client" },
//                  { src: "/logos/venkateshwar_logo.png", alt: "Venkateshwar Client" },
//                  { src: "/logos/ncf.png", alt: "NCF Client" },
//             ].map((logo, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{ scale: 1.1, rotate: 5 }}
//                 transition={{ duration: 0.3 }}
//               >
//                 <img
//                   src={logo.src}
//                   className="mx-5 shadow-sm p-2 rounded"
//                   alt={logo.alt}
//                   height="130"
//                 />
//               </motion.div>
//             ))}
//           </Marquee>
//         </motion.div>
//       </motion.div>

//       {/* Testimonials Section - KEEPS EFFECTS */}
// {/* Testimonials Section - SIMPLIFIED AND CLEAN */}
// <motion.div 
//   ref={testimonialsRef}
//   className="testimonials-section py-5"
//   style={{
//     background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
//     position: "relative",
//     overflow: "hidden"
//   }}
//   initial="hidden"
//   animate={testimonialsInView ? "visible" : "hidden"}
//   variants={staggerContainer}
// >
//   {/* Animated Background Elements */}
//   <div className="testimonials-bg-animation">
//     {[...Array(12)].map((_, i) => (
//       <motion.div
//         key={i}
//         className="floating-shape"
//         animate={{
//           x: [0, 50, 0],
//           y: [0, -30, 0],
//           rotate: [0, 180, 360],
//           scale: [1, 1.2, 1],
//         }}
//         transition={{
//           duration: 6 + Math.random() * 4,
//           repeat: Infinity,
//           delay: Math.random() * 3,
//         }}
//         style={{
//           position: 'absolute',
//           left: `${Math.random() * 100}%`,
//           top: `${Math.random() * 100}%`,
//           width: `${15 + Math.random() * 25}px`,
//           height: `${15 + Math.random() * 25}px`,
//           background: `linear-gradient(45deg, rgba(13,110,253,0.1), rgba(36,62,124,0.1))`,
//           borderRadius: Math.random() > 0.5 ? '50%' : '20%',
//           filter: 'blur(1px)',
//         }}
//       />
//     ))}
//   </div>

//   <div className="container py-4 position-relative">
//     <div className="row justify-content-center">
//       <div className="col-lg-11">
//         <motion.div className="text-center mb-5" variants={fadeInUp}>
//           <div className="section-header mb-4">
//             <motion.div
//               className="section-badge mx-auto mb-3"
//               style={{
//                 background: "linear-gradient(135deg, #0d6efd, #243e7c)",
//                 color: "white",
//                 padding: "8px 24px",
//                 borderRadius: "25px",
//                 display: "inline-block",
//                 fontSize: "14px",
//                 fontWeight: "600",
//                 textTransform: "uppercase",
//                 letterSpacing: "1px"
//               }}
//               whileHover={{ scale: 1.05, y: -2 }}
//             >
//               ✨ Team Stories
//             </motion.div>
//             <h2 className="display-5 fw-bold mb-3 gradient-text">
//               Hear From Our Team
//             </h2>
//             <div className="underline-decorator mx-auto mb-4"></div>
//             <p className="lead text-muted mx-auto" style={{ maxWidth: "600px" }}>
//               Discover the experiences and growth journeys of our talented team members
//             </p>
//           </div>

//           {/* Enhanced Tab Navigation */}
//           <div className="tab-navigation-wrapper mb-5">
//             <div className="btn-group tab-buttons shadow-sm" role="group">
//               <motion.button
//                 type="button"
//                 className={`btn tab-btn ${activeTab === 'interns' ? 'active' : ''}`}
//                 onClick={() => handleTabChange('interns')}
//                 whileHover={{ scale: 1.02 }}
//                 whileTap={{ scale: 0.98 }}
//               >
//                 <i className="bi bi-mortarboard me-2"></i>
//                 <strong>Interns</strong>
//                 {/* <span className="badge ms-2">{interns.length}</span> */}
//               </motion.button>
//               {/* <motion.button
//                 type="button"
//                 className={`btn tab-btn ${activeTab === 'employees' ? 'active' : ''}`}
//                 onClick={() => handleTabChange('employees')}
//                 whileHover={{ scale: 1.02 }}
//                 whileTap={{ scale: 0.98 }}
//               >
//                 <i className="bi bi-people me-2"></i>
//                 <strong>Employees</strong>
//                 <span className="badge ms-2">{employees.length}</span>
//               </motion.button> */}
//             </div>
//           </div>
//         </motion.div>

//         {/* Simplified Testimonial Carousel */}
//         <motion.div variants={fadeInUp}>
//           <Swiper
//             modules={[Pagination, Autoplay]}
//             spaceBetween={25}
//             pagination={false} // Removed pagination dots
//             autoplay={{
//               delay: 4000,
//               disableOnInteraction: false,
//               pauseOnMouseEnter: true,
//             }}
//             loop={true} // Enable infinite loop
//             slidesPerView={1}
//             breakpoints={{
//               576: {
//                 slidesPerView: 1,
//                 spaceBetween: 20,
//               },
//               768: {
//                 slidesPerView: 2,
//                 spaceBetween: 25,
//               },
//               1200: {
//                 slidesPerView: 3,
//                 spaceBetween: 30,
//               },
//             }}
//             className="simplified-testimonial-swiper"
//             key={activeTab}
//           >
//             {currentTestimonials.map((testimonial, index) => (
//               <SwiperSlide key={testimonial.id}>
//                 <motion.div 
//                   className="testimonial-card-simplified"
//                   initial={{ opacity: 0, y: 50 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ 
//                     delay: index * 0.1,
//                     duration: 0.6,
//                     ease: "easeOut"
//                   }}
//                   whileHover={{ 
//                     y: -15,
//                     scale: 1.02,
//                     transition: { duration: 0.3 }
//                   }}
//                 >
//                   {/* Card Background with Gradient */}
//                   <div className="card-bg-gradient"></div>

//                   {/* Quote Icon */}
//                   <div className="quote-icon">
//                     <i className="bi bi-quote text-primary"></i>
//                   </div>

//                   <div className="card-content">
//                     {/* Profile Section */}
//                     <div className="profile-section mb-4">
//                       <motion.div
//                         className="profile-avatar"
//                         whileHover={{ scale: 1.1, rotate: 5 }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <div className="avatar-circle">
//                           <span className="avatar-initials">{testimonial.initials}</span>
//                         </div>
//                         <div className="avatar-ring"></div>
//                       </motion.div>
//                       <div className="profile-info">
//                         <h4 className="profile-name">{testimonial.name}</h4>
//                         <div className="position-badge">
//                           <i className="bi bi-briefcase me-1"></i>
//                           {testimonial.position}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Testimonial Text */}
//                     <div className="testimonial-text-container">
//                       <p className="testimonial-text">
//                         "{testimonial.quote}"
//                       </p>
//                     </div>
//                   </div>
//                 </motion.div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </motion.div>
//       </div>
//     </div>
//   </div>
// </motion.div>

// {/* Simplified Custom CSS */}
// <style jsx>{`
//   /* Enhanced Testimonials Section */
//   .testimonials-section {
//     position: relative;
//     min-height: 80vh;
//   }

//   .testimonials-bg-animation {
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     pointer-events: none;
//     z-index: 0;
//   }

//   /* Section Header Enhancements */
//   .gradient-text {
//     background: linear-gradient(135deg, #0d6efd, #243e7c);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//   }

//   .underline-decorator {
//     width: 80px;
//     height: 4px;
//     background: linear-gradient(90deg, #0d6efd, #243e7c);
//     border-radius: 2px;
//   }

//   /* Enhanced Tab Navigation */
//   .tab-navigation-wrapper {
//     display: flex;
//     justify-content: center;
//   }

//   .tab-buttons {
//     border-radius: 50px;
//     overflow: hidden;
//     border: none;
//     background: white;
//   }

//   .tab-btn {
//     padding: 12px 28px;
//     border: none;
//     background: white;
//     color: #6c757d;
//     font-weight: 500;
//     transition: all 0.3s ease;
//     position: relative;
//     overflow: hidden;
//   }

//   .tab-btn:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(135deg, #0d6efd, #243e7c);
//     transition: left 0.3s ease;
//     z-index: -1;
//   }

//   .tab-btn.active:before,
//   .tab-btn:hover:before {
//     left: 0;
//   }

//   .tab-btn.active,
//   .tab-btn:hover {
//     color: white;
//     transform: translateY(-2px);
//     box-shadow: 0 8px 25px rgba(13, 110, 253, 0.3);
//   }

//   .tab-btn .badge {
//     background: rgba(255, 255, 255, 0.2);
//     font-size: 10px;
//     padding: 2px 6px;
//   }

//   /* Simplified Testimonial Cards */
//   .testimonial-card-simplified {
//     background: white;
//     border-radius: 24px;
//     padding: 0;
//     height: 400px; /* Fixed height for consistency */
//     width: 100%; /* Fixed width for consistency */
//     position: relative;
//     overflow: hidden;
//     box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//     border: 1px solid rgba(255, 255, 255, 0.2);
//     backdrop-filter: blur(10px);
//     cursor: pointer;
//   }

//   .card-bg-gradient {
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: linear-gradient(135deg, 
//       rgba(13, 110, 253, 0.02) 0%, 
//       rgba(36, 62, 124, 0.02) 100%);
//     pointer-events: none;
//   }

//   .testimonial-card-simplified:hover .card-bg-gradient {
//     background: linear-gradient(135deg, 
//       rgba(13, 110, 253, 0.05) 0%, 
//       rgba(36, 62, 124, 0.05) 100%);
//   }

//   .quote-icon {
//     position: absolute;
//     top: -15px;
//     right: 20px;
//     width: 60px;
//     height: 60px;
//     background: linear-gradient(135deg, #0d6efd, #243e7c);
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 24px;
//     color: white;
//     z-index: 2;
//     box-shadow: 0 8px 25px rgba(13, 110, 253, 0.3);
//   }

//   .card-content {
//     padding: 40px 30px 30px;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     position: relative;
//     z-index: 1;
//   }

//   /* Profile Section */
//   .profile-section {
//     display: flex;
//     align-items: center;
//     gap: 16px;
//     flex-shrink: 0; /* Prevent shrinking */
//   }

//   .profile-avatar {
//     position: relative;
//     flex-shrink: 0;
//   }

//   .avatar-circle {
//     width: 70px;
//     height: 70px;
//     background: linear-gradient(135deg, #0d6efd, #243e7c);
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     position: relative;
//     z-index: 2;
//   }

//   .avatar-initials {
//     color: white;
//     font-size: 18px;
//     font-weight: 700;
//   }

//   .avatar-ring {
//     position: absolute;
//     top: -5px;
//     left: -5px;
//     right: -5px;
//     bottom: -5px;
//     border: 2px solid rgba(13, 110, 253, 0.3);
//     border-radius: 50%;
//     animation: pulse-ring 2s infinite;
//   }

//   @keyframes pulse-ring {
//     0% { transform: scale(1); opacity: 1; }
//     100% { transform: scale(1.2); opacity: 0; }
//   }

//   .profile-info {
//     flex: 1;
//     min-width: 0;
//   }

//   .profile-name {
//     font-size: 18px;
//     font-weight: 700;
//     color: #2c3e50;
//     margin: 0 0 6px 0;
//     line-height: 1.3;
//   }

//   .position-badge {
//     background: linear-gradient(135deg, rgba(13, 110, 253, 0.1), rgba(36, 62, 124, 0.1));
//     color: #0d6efd;
//     padding: 6px 12px;
//     border-radius: 20px;
//     font-size: 12px;
//     font-weight: 600;
//     display: inline-flex;
//     align-items: center;
//     border: 1px solid rgba(13, 110, 253, 0.2);
//   }

//   /* Testimonial Text */
//   .testimonial-text-container {
//     flex: 1; /* Take remaining space */
//     margin: 20px 0;
//     overflow-y: auto; /* Allow scrolling for long text */
//   }

//   .testimonial-text {
//     color: #5a6c7d;
//     font-size: 14px;
//     line-height: 1.6;
//     margin: 0;
//     font-style: italic;
//     position: relative;
//     padding-left: 20px;
//   }

//   .testimonial-text:before {
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 0;
//     bottom: 0;
//     width: 3px;
//     background: linear-gradient(135deg, #0d6efd, #243e7c);
//     border-radius: 2px;
//   }

//   /* Custom Scrollbar for testimonial text */
//   .testimonial-text-container::-webkit-scrollbar {
//     width: 4px;
//   }

//   .testimonial-text-container::-webkit-scrollbar-track {
//     background: transparent;
//   }

//   .testimonial-text-container::-webkit-scrollbar-thumb {
//     background: rgba(13, 110, 253, 0.3);
//     border-radius: 2px;
//   }

//   /* Swiper Customizations */
//   .simplified-testimonial-swiper {
//     padding-bottom: 20px;
//   }

//   .simplified-testimonial-swiper .swiper-slide {
//     height: auto;
//     display: flex;
//     align-items: stretch;
//   }

//   /* Responsive Design */
//   @media (max-width: 1200px) {
//     .card-content {
//       padding: 30px 25px 25px;
//     }

//     .testimonial-card-simplified {
//       height: 380px;
//     }
//   }

//   @media (max-width: 768px) {
//     .profile-section {
//       flex-direction: column;
//       text-align: center;
//       gap: 12px;
//     }

//     .card-content {
//       padding: 25px 20px 20px;
//     }

//     .testimonial-card-simplified {
//       height: 360px;
//     }

//     .profile-name {
//       font-size: 16px;
//     }

//     .testimonial-text {
//       font-size: 13px;
//     }

//     .tab-btn {
//       padding: 10px 20px;
//       font-size: 14px;
//     }

//     .quote-icon {
//       width: 50px;
//       height: 50px;
//       font-size: 20px;
//       top: -10px;
//       right: 15px;
//     }
//   }

//   @media (max-width: 576px) {
//     .display-5 {
//       font-size: 1.8rem;
//     }

//     .card-content {
//       padding: 20px 15px 15px;
//     }

//     .testimonial-card-simplified {
//       height: 340px;
//     }

//     .avatar-circle {
//       width: 60px;
//       height: 60px;
//     }

//     .avatar-initials {
//       font-size: 16px;
//     }

//     .profile-name {
//       font-size: 15px;
//     }

//     .testimonial-text {
//       font-size: 12px;
//       padding-left: 15px;
//     }

//     .simplified-testimonial-swiper {
//       padding-bottom: 15px;
//     }
//   }

//   /* Accessibility Improvements */
//   @media (prefers-reduced-motion: reduce) {
//     .testimonial-card-simplified,
//     .tab-btn {
//       transition: none;
//     }

//     .avatar-ring {
//       animation: none;
//     }
//   }

//   /* Focus States */
//   .tab-btn:focus {
//     outline: 2px solid #0d6efd;
//     outline-offset: 2px;
//   }

//   /* Dark Mode Support */
//   @media (prefers-color-scheme: dark) {
//     .testimonials-section {
//       background: linear-gradient(135deg, #1a1d29 0%, #16213e 100%);
//     }

//     .testimonial-card-simplified {
//       background: rgba(255, 255, 255, 0.05);
//       border-color: rgba(255, 255, 255, 0.1);
//     }

//     .profile-name {
//       color: white;
//     }

//     .testimonial-text {
//       color: rgba(255, 255, 255, 0.8);
//     }
//   }
// `}</style>
//     </>
//   );
// };

// export default Home;
import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { CheckCircleFill, ArrowRight, ChevronRight } from "react-bootstrap-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Marquee from "react-fast-marquee";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { NavLink } from "react-router-dom";
import { AiOutlinePlus, AiOutlineArrowRight } from "react-icons/ai";
import { FcAdvertising } from "react-icons/fc";
import { Autoplay } from "swiper";
import {
  FaCode,
  FaMobileAlt,
  FaDatabase,
  FaCloud,
  FaDesktop,
  FaChartBar,
  FaUniversity,
  FaMoneyBillWave,
  FaBriefcase,
  FaUtensils,
  FaPlane,
  FaTruck,
  FaGem,
  FaTint,
  FaSeedling,
  FaCog,
  FaCalendarAlt,
  FaDownload,
  FaRocket,
  FaShieldAlt,
  FaBullseye,
  FaLightbulb,
  FaUsers,
  FaAward
} from "react-icons/fa";
import { motion, useScroll, useTransform, useInView, AnimatePresence, useMotionValueEvent, useSpring } from "framer-motion";
import IndustriesSection from "../../components/Industries";
import ApproachScrollSectionNew from "../../components/ApproachScrollSection";
import { Search, Lightbulb, Compass, Code2, Bug, Rocket as LucideRocket } from "lucide-react";

// Custom hook for intersection observer
const useIntersectionObserver = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, {
      threshold: 0.1,
      rootMargin: '-50px',
      ...options
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return [ref, isIntersecting];
};

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

const slideInLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const slideInRight = {
  hidden: { opacity: 0, x: 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

// ─── CINEMATIC HERO SECTION with Zoom In/Out Text Animations ───
const TYPING_WORDS = ["Web Development", "Mobile Apps", "IoT Solutions", "AI & ML", "Cloud Services", "Enterprise Software"];

const Slider = () => {
  const [typingIndex, setTypingIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);
  const [particlePositions] = useState(() =>
    Array.from({ length: 60 }, (_, i) => ({
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: 1 + Math.random() * 3,
      duration: 3 + Math.random() * 7,
      delay: Math.random() * 5,
      opacity: 0.1 + Math.random() * 0.5,
    }))
  );

  // Typing animation effect
  useEffect(() => {
    const current = TYPING_WORDS[typingIndex];
    let timer;
    if (!isDeleting && charIndex < current.length) {
      timer = setTimeout(() => {
        setDisplayText(current.slice(0, charIndex + 1));
        setCharIndex(c => c + 1);
      }, 80);
    } else if (!isDeleting && charIndex === current.length) {
      timer = setTimeout(() => setIsDeleting(true), 1800);
    } else if (isDeleting && charIndex > 0) {
      timer = setTimeout(() => {
        setDisplayText(current.slice(0, charIndex - 1));
        setCharIndex(c => c - 1);
      }, 40);
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setTypingIndex(t => (t + 1) % TYPING_WORDS.length);
    }
    return () => clearTimeout(timer);
  }, [charIndex, isDeleting, typingIndex]);



  return (
    <div
      style={{
        minHeight: "calc(100vh - 50px)",
        background: "linear-gradient(135deg, #dff0ff 0%, #c8e6ff 30%, #b3d9ff 60%, #e8f4ff 100%)",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        fontFamily: "'Inter', 'Plus Jakarta Sans', sans-serif",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      {/* ── Background Watermark Circles (global) ── */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0, overflow: "hidden" }}>
        {/* Top-left large circle */}
        <div style={{
          position: "absolute", top: "-120px", left: "-120px",
          width: "420px", height: "420px", borderRadius: "50%",
          background: "rgba(26,80,137,0.07)",
        }} />
        {/* Bottom-right large circle */}
        <div style={{
          position: "absolute", bottom: "-100px", right: "-80px",
          width: "380px", height: "380px", borderRadius: "50%",
          background: "rgba(26,80,137,0.06)",
        }} />
        {/* Center-right medium circle */}
        <div style={{
          position: "absolute", top: "30%", right: "-60px",
          width: "260px", height: "260px", borderRadius: "50%",
          background: "rgba(61,144,215,0.06)",
        }} />
        {/* Bottom-left small circle */}
        <div style={{
          position: "absolute", bottom: "5%", left: "5%",
          width: "150px", height: "150px", borderRadius: "50%",
          background: "rgba(26,80,137,0.05)",
        }} />
        {/* Large background text watermark */}
        <div style={{
          position: "absolute",
          top: "12%",
          left: "2%",
          fontSize: "clamp(4rem, 11vw, 10rem)",
          fontWeight: "900",
          color: "rgba(99, 167, 239, 0.04)",
          fontFamily: "'Inter', sans-serif",
          whiteSpace: "nowrap",
          userSelect: "none",
          pointerEvents: "none",
          zIndex: 0,
          letterSpacing: "-4px",
        }}>
          INNOVATIVE SOLUTIONS
        </div>
      </div>

      {/* ── Particle field ── */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 1 }}>
        {particlePositions.map((p, i) => (
          <motion.div
            key={i}
            style={{
              position: "absolute",
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              borderRadius: "50%",
              background: i % 3 === 0 ? "#1a5089" : i % 3 === 1 ? "#0d7ec9" : "#3D90D7",
              opacity: p.opacity * 0.5,
            }}
            animate={{
              y: [0, -30, 0],
              opacity: [p.opacity, p.opacity * 0.3, p.opacity],
              scale: [1, 1.5, 1],
            }}
            transition={{
              duration: p.duration,
              delay: p.delay,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      {/* ── Glowing orbs ── */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 1 }}>
        <motion.div
          style={{
            position: "absolute", top: "10%", left: "-5%",
            width: "500px", height: "500px", borderRadius: "50%",
            background: "radial-gradient(circle, rgba(61,144,215,0.25) 0%, transparent 70%)",
            filter: "blur(60px)",
          }}
          animate={{ scale: [1, 1.2, 1], opacity: [0.4, 0.7, 0.4] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          style={{
            position: "absolute", bottom: "10%", right: "-5%",
            width: "400px", height: "400px", borderRadius: "50%",
            background: "radial-gradient(circle, rgba(26,80,137,0.15) 0%, transparent 70%)",
            filter: "blur(60px)",
          }}
          animate={{ scale: [1, 1.3, 1], opacity: [0.2, 0.5, 0.2] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        />
        <motion.div
          style={{
            position: "absolute", top: "50%", left: "40%",
            width: "300px", height: "300px", borderRadius: "50%",
            background: "radial-gradient(circle, rgba(61,144,215,0.15) 0%, transparent 70%)",
            filter: "blur(40px)",
          }}
          animate={{ scale: [1, 1.4, 1], opacity: [0.15, 0.4, 0.15] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        />
      </div>

      {/* Grid overlay removed */}



      {/* ── Main Content ── */}
      <Container style={{ position: "relative", zIndex: 10 }}>
        <Row className="align-items-center" style={{ minHeight: "calc(100vh - 120px)", paddingTop: "20px" }}>

          {/* LEFT: Text content */}
          <Col lg={6} className="mb-4 mb-lg-0">

            {/* Badge */}
            {/* <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mb-4"
            >
              <span style={{
                display: "inline-flex", alignItems: "center", gap: "10px",
                background: "rgba(26,80,137,0.1)",
                border: "1.5px solid rgba(26,80,137,0.35)",
                borderRadius: "100px", padding: "10px 22px",
                color: "#0d3b72", fontSize: "12px", fontWeight: "800",
                textTransform: "uppercase", letterSpacing: "2px",
                backdropFilter: "blur(8px)",
                boxShadow: "0 4px 16px rgba(26,80,137,0.1)",
              }}>
                <motion.span
                  animate={{ rotate: [0, 360] }}
                  transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                >
                  🚀
                </motion.span>
                Award-Winning IT Company  
              </span>
            </motion.div> */}

            {/* Main heading with zoom in/out animation */}
            <motion.div
              initial={{ opacity: 0, scale: 0.7, y: 40 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.4, type: "spring", stiffness: 80 }}
            >
              <h1 style={{
                fontSize: "clamp(3rem, 7.5vw, 5.8rem)",
                fontWeight: "900",
                lineHeight: "1.08",
                color: "#0a1e3d",
                letterSpacing: "-2px",
                marginBottom: "8px",
                textShadow: "0 2px 8px rgba(10,30,61,0.08)",
                fontFamily: "'Inter', sans-serif",
              }}>
                {/* "The" - zoom pulse */}
                <motion.span
                  style={{ display: "inline-block" }}
                  animate={{ scale: [1, 1.04, 1] }}
                  transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                >
                  The
                </motion.span>{" "}
                {/* "Innovative" - zoom in-out with gold shimmer */}
                <motion.span
                  style={{
                    display: "inline-block",
                    background: "linear-gradient(135deg, #1a5089 0%, #3D90D7 50%, #0d7ec9 100%)",
                    backgroundSize: "200% 200%",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                  animate={{
                    scale: [1, 1.06, 1, 0.97, 1],
                    backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
                  }}
                  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                >
                  Innovative
                </motion.span>
                <br />
                {/* "Solutions" - zoom out-in */}
                <motion.span
                  style={{ display: "inline-block", color: "#0a1e3d" }}
                  animate={{ scale: [1, 0.95, 1, 1.03, 1] }}
                  transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                >
                  Solutions
                </motion.span>
              </h1>
            </motion.div>

            {/* Typing effect subtitle */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.7 }}
              style={{ marginBottom: "12px" }}
            >
              <div style={{
                display: "flex", alignItems: "center", gap: "10px",
                fontSize: "clamp(1.05rem, 2.5vw, 1.5rem)", fontWeight: "800",
                color: "#0d3b72",
                fontFamily: "'Inter', sans-serif",
              }}>
                <span style={{ opacity: 0.8 }}>Experts in</span>
                <span style={{
                  borderRight: "3px solid #3D90D7",
                  paddingRight: "6px",
                  color: "#3D90D7",
                  minWidth: "220px",
                  letterSpacing: "-0.3px",
                }}>
                  {displayText}
                </span>
              </div>
            </motion.div>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.9 }}
              style={{
                fontSize: "1rem",
                color: "#3a5278",
                lineHeight: "1.6",
                maxWidth: "500px",
                marginBottom: "20px",
                fontWeight: "500",
                letterSpacing: "0.1px",
              }}
            >
              Award-winning software development company delivering cutting-edge web, mobile, IoT, and AI solutions that drive digital transformation across industries.
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 1.1 }}
              style={{ display: "flex", flexWrap: "nowrap", gap: "12px", marginBottom: "25px", alignItems: "center" }}
            >
              <motion.div whileHover={{ scale: 1.04, y: -4 }} whileTap={{ scale: 0.97 }}>
                <NavLink
                  to="/portfolio"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "10px",
                    background: "linear-gradient(135deg, #1a5089 0%, #2871b8 100%)",
                    border: "none", borderRadius: "50px",
                    padding: "13px 24px",
                    fontWeight: "800", fontSize: "14px", color: "white",
                    textDecoration: "none",
                    boxShadow: "0 10px 35px rgba(26,80,137,0.45)",
                    letterSpacing: "0.2px",
                  }}
                >
                  View Portfolio <ArrowRight size={17} />
                </NavLink>
              </motion.div>

              <motion.div whileHover={{ scale: 1.04, y: -4 }} whileTap={{ scale: 0.97 }}>
                <a
                  href="/Brochure/Brochure.pdf"
                  download="The-Innovative-Solutions-Brochure.pdf"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "10px",
                    background: "rgba(255,255,255,0.9)",
                    border: "2px solid rgba(26,80,137,0.3)", borderRadius: "50px",
                    padding: "11px 22px",
                    fontWeight: "800", fontSize: "14px", color: "#1a5089",
                    textDecoration: "none",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 8px 25px rgba(26,80,137,0.15)",
                    letterSpacing: "0.2px",
                  }}
                >
                  <FaDownload size={14} /> Download Brochure
                </a>
              </motion.div>

              <motion.div whileHover={{ scale: 1.04, y: -4 }} whileTap={{ scale: 0.97 }}>
                <NavLink
                  to="/contact"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "10px",
                    background: "transparent",
                    border: "2px solid rgba(26,80,137,0.4)", borderRadius: "50px",
                    padding: "11px 22px",
                    fontWeight: "800", fontSize: "14px", color: "#1a5089",
                    textDecoration: "none",
                    letterSpacing: "0.2px",
                  }}
                >
                  Schedule Consultation <ChevronRight size={16} />
                </NavLink>
              </motion.div>
            </motion.div>

            {/* Feature pills */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7, delay: 1.3 }}
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              {["Agile Development", "Enterprise Grade", "Cloud Native", "AI-Powered"].map((tag, i) => (
                <motion.span
                  key={i}
                  style={{
                    background: "rgba(255,255,255,0.85)",
                    border: "1.5px solid rgba(26,80,137,0.25)",
                    borderRadius: "100px", padding: "7px 16px",
                    color: "#0d3b72", fontSize: "12.5px", fontWeight: "700",
                    backdropFilter: "blur(8px)",
                    boxShadow: "0 2px 10px rgba(26,80,137,0.08)",
                    letterSpacing: "0.1px",
                  }}
                  whileHover={{
                    background: "rgba(26,80,137,0.95)",
                    border: "1.5px solid rgba(26,80,137,0.8)",
                    color: "#ffffff",
                    scale: 1.06,
                    boxShadow: "0 6px 20px rgba(26,80,137,0.3)",
                  }}
                  transition={{ duration: 0.2 }}
                >
                  ✦ {tag}
                </motion.span>
              ))}
            </motion.div>
          </Col>

          {/* RIGHT: Circular image + floating cards inside locked orbital container */}
          <Col lg={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.7, x: 60 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5, type: "spring", stiffness: 60 }}
              style={{
                position: "relative",
                width: "480px",
                height: "480px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              {/* ── Main circular image (Centered inside 480x480 container) ── */}
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                style={{
                  position: "relative",
                  zIndex: 5,
                  width: "320px", height: "320px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "6px solid #ffffff",
                  boxShadow: "0 25px 55px rgba(26,80,137,0.22), 0 0 0 1px rgba(26,80,137,0.08)",
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&auto=format&fit=crop&q=80"
                  alt="Professional IT Team"
                  style={{
                    width: "100%", height: "100%",
                    objectFit: "cover",
                    objectPosition: "center top",
                  }}
                />
                {/* Subtle blue overlay */}
                <div style={{
                  position: "absolute", inset: 0,
                  background: "linear-gradient(160deg, rgba(199,230,255,0.1) 0%, transparent 60%)",
                }} />
              </motion.div>

              {/* ── Floating Card 1: Top Left — Projects Done ── */}
              <motion.div
                style={{
                  position: "absolute",
                  top: "70px", left: "-25px",
                  background: "rgba(255,255,255,0.92)",
                  backdropFilter: "blur(18px)",
                  border: "1.5px solid rgba(255,255,255,0.6)",
                  borderRadius: "16px",
                  padding: "12px 16px",
                  zIndex: 10,
                  boxShadow: "0 12px 30px rgba(26,80,137,0.08), 0 4px 10px rgba(0,0,0,0.03)",
                  minWidth: "155px",
                  display: "flex", alignItems: "center", gap: "12px",
                }}
                animate={{ y: [0, -10, 0], rotate: [0, -1, 0] }}
                transition={{ duration: 4.2, repeat: Infinity, ease: "easeInOut" }}
                whileHover={{ scale: 1.06, y: -4 }}
              >
                <div style={{
                  width: "38px", height: "38px", borderRadius: "10px",
                  background: "linear-gradient(135deg, rgba(61,144,215,0.15) 0%, rgba(26,80,137,0.15) 100%)",
                  border: "1px solid rgba(26,80,137,0.1)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  <span style={{ fontSize: "18px" }}>🚀</span>
                </div>
                <div>
                  <div style={{ fontSize: "1.35rem", fontWeight: "900", color: "#1a5089", lineHeight: 1 }}>50+</div>
                  <div style={{ fontSize: "11px", color: "#4f6785", fontWeight: "700", marginTop: "2px", letterSpacing: "0.2px" }}>Projects Done</div>
                </div>
              </motion.div>

              {/* ── Floating Card 2: Bottom Right — Satisfaction ── */}
              <motion.div
                style={{
                  position: "absolute",
                  bottom: "80px", right: "-25px",
                  background: "rgba(255,255,255,0.92)",
                  backdropFilter: "blur(18px)",
                  border: "1.5px solid rgba(255,255,255,0.6)",
                  borderRadius: "16px",
                  padding: "12px 16px",
                  zIndex: 10,
                  boxShadow: "0 12px 30px rgba(26,80,137,0.08), 0 4px 10px rgba(0,0,0,0.03)",
                  minWidth: "155px",
                  display: "flex", alignItems: "center", gap: "12px",
                }}
                animate={{ y: [0, 8, 0], rotate: [0, 1.5, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                whileHover={{ scale: 1.06, y: -4 }}
              >
                <div style={{
                  width: "38px", height: "38px", borderRadius: "10px",
                  background: "linear-gradient(135deg, rgba(0,184,148,0.15) 0%, rgba(0,120,95,0.15) 100%)",
                  border: "1px solid rgba(0,120,95,0.1)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  <span style={{ fontSize: "18px" }}>✅</span>
                </div>
                <div>
                  <div style={{ fontSize: "1.35rem", fontWeight: "900", color: "#00785f", lineHeight: 1 }}>98%</div>
                  <div style={{ fontSize: "11px", color: "#4f6785", fontWeight: "700", marginTop: "2px", letterSpacing: "0.2px" }}>Satisfaction</div>
                </div>
              </motion.div>

              {/* ── Floating Card 3: Bottom Left — Years Exp (Accent highlight) ── */}
              <motion.div
                style={{
                  position: "absolute",
                  bottom: "65px", left: "-20px",
                  background: "linear-gradient(135deg, #1a5089 0%, #3D90D7 100%)",
                  borderRadius: "16px",
                  padding: "12px 16px",
                  zIndex: 10,
                  boxShadow: "0 16px 36px rgba(26,80,137,0.25)",
                  minWidth: "135px",
                  display: "flex", alignItems: "center", gap: "12px",
                }}
                animate={{ y: [0, -8, 0], rotate: [0, -1.5, 0] }}
                transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                whileHover={{ scale: 1.06, y: -4 }}
              >
                <div style={{
                  width: "38px", height: "38px", borderRadius: "10px",
                  background: "rgba(255,255,255,0.2)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  <span style={{ fontSize: "18px" }}>🏆</span>
                </div>
                <div>
                  <div style={{ fontSize: "1.35rem", fontWeight: "900", color: "#ffffff", lineHeight: 1 }}>4+</div>
                  <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.85)", fontWeight: "700", marginTop: "2px", letterSpacing: "0.2px" }}>Yrs Experience</div>
                </div>
              </motion.div>

              {/* ── Floating Card 4: React.js Tech Pill ── */}
              <motion.div
                style={{
                  position: "absolute",
                  top: "20px", right: "20px",
                  background: "rgba(255, 255, 255, 0.38)",
                  backdropFilter: "blur(12px)",
                  border: "1.5px solid rgba(97, 218, 251, 0.22)",
                  borderRadius: "12px",
                  padding: "8px 14px",
                  display: "flex", alignItems: "center", gap: "8px",
                  boxShadow: "0 8px 24px rgba(97,218,251,0.06)",
                  zIndex: 10,
                }}
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
                whileHover={{ scale: 1.06, y: -4 }}
              >
                <span style={{ fontSize: "16px", opacity: 0.32 }}>⚛️</span>
                <span style={{ color: "#0d8ecf", fontWeight: "700", fontSize: "12.5px", letterSpacing: "0.1px", opacity: 0.38 }}>React.js</span>
              </motion.div>

              {/* ── Floating Card 5: Mobile Tech Pill ── */}
              <motion.div
                style={{
                  position: "absolute",
                  top: "215px", right: "-30px",
                  background: "rgba(255, 255, 255, 0.38)",
                  backdropFilter: "blur(12px)",
                  border: "1.5px solid rgba(162, 155, 254, 0.22)",
                  borderRadius: "12px",
                  padding: "8px 14px",
                  display: "flex", alignItems: "center", gap: "8px",
                  boxShadow: "0 8px 24px rgba(162,155,254,0.06)",
                  zIndex: 10,
                }}
                animate={{ y: [0, 10, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                whileHover={{ scale: 1.06, y: -4 }}
              >
                <span style={{ fontSize: "16px", opacity: 0.32 }}>📱</span>
                <span style={{ color: "#7d75e2", fontWeight: "700", fontSize: "12.5px", letterSpacing: "0.1px", opacity: 0.38 }}>Mobile</span>
              </motion.div>

              {/* ── Floating Card 6: Cloud Tech Pill ── */}
              <motion.div
                style={{
                  position: "absolute",
                  bottom: "-10px", left: "165px",
                  background: "rgba(255, 255, 255, 0.38)",
                  backdropFilter: "blur(12px)",
                  border: "1.5px solid rgba(78, 205, 196, 0.22)",
                  borderRadius: "12px",
                  padding: "8px 14px",
                  display: "flex", alignItems: "center", gap: "8px",
                  boxShadow: "0 8px 24px rgba(78,205,196,0.06)",
                  zIndex: 10,
                }}
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 4.8, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                whileHover={{ scale: 1.06, y: -4 }}
              >
                <span style={{ fontSize: "16px", opacity: 0.32 }}>☁️</span>
                <span style={{ color: "#0d9488", fontWeight: "700", fontSize: "12.5px", letterSpacing: "0.1px", opacity: 0.38 }}>Cloud</span>
              </motion.div>

            </motion.div>
          </Col>
        </Row>
      </Container>



      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

        @media (max-width: 991px) {
          .col-lg-6:last-child {
            display: none;
          }
        }
        @media (max-width: 768px) {
          h1 { text-align: center !important; }
          .hero-typing { justify-content: center !important; }
          .hexagon-cluster {
            transform: scale(0.8);
            transform-origin: center top;
            height: 340px !important;
            margin-bottom: 40px !important;
          }
        }
        @media (max-width: 480px) {
          .hexagon-cluster {
            transform: scale(0.65);
            transform-origin: center top;
            height: 280px !important;
            margin-bottom: 60px !important;
          }
        }
      `}</style>
    </div>
  );
};

/* ─── Scroll-Linked Approach Step Card ─── */
const APPROACH_STEPS = [
  {
    title: "Discovery",
    icon: <Search size={24} />,
    desc: "We learn about your business, goals, and challenges to establish a clear vision.",
    color: "#1d4fa0",
    lightColor: "rgba(29,79,160,0.12)",
    badge: "FOUNDER'S VISION",
    subtitle: "EARLY DAYS",
    detailedTitle: "Discovery & Analysis"
  },
  {
    title: "Strategy",
    icon: <Lightbulb size={24} />,
    desc: "Our experts develop a comprehensive plan tailored to your specific requirements.",
    color: "#2a6ec9",
    lightColor: "rgba(42,110,201,0.12)",
    badge: "STRATEGY ROADMAP",
    subtitle: "PLANNING STAGE",
    detailedTitle: "Strategy & Planning"
  },
  {
    title: "Design",
    icon: <Compass size={24} />,
    desc: "We create intuitive interfaces and architectures optimized for performance.",
    color: "#3685d6",
    lightColor: "rgba(54,133,214,0.12)",
    badge: "CREATIVE BLUEPRINT",
    subtitle: "UI/UX WIREFRAMES",
    detailedTitle: "Design & Architecture"
  },
  {
    title: "Development",
    icon: <Code2 size={24} />,
    desc: "Our engineers build robust solutions using industry-leading technologies.",
    color: "#4d90d6",
    lightColor: "rgba(77,144,214,0.12)",
    badge: "ROBUST CODING",
    subtitle: "ENGINEERING",
    detailedTitle: "Technical Development"
  },
  {
    title: "Testing",
    icon: <Bug size={24} />,
    desc: "Rigorous quality assurance ensures your solution performs flawlessly.",
    color: "#3a7fbf",
    lightColor: "rgba(58,127,191,0.12)",
    badge: "QUALITY ASSURANCE",
    subtitle: "BUG HUNTING",
    detailedTitle: "Quality Assurance"
  },
  {
    title: "Launch",
    icon: <LucideRocket size={24} />,
    desc: "We deploy your solution and provide comprehensive training and support.",
    color: "#243e7c",
    lightColor: "rgba(36,62,124,0.12)",
    badge: "PRODUCTION RELEASE",
    subtitle: "GOING LIVE",
    detailedTitle: "Deployment & Support"
  },
];

/* ─── Sticky Scroll Approach Section ─── */
/* ─── Scroll-Linked Approach Step Card ─── */
/* ─── Redesigned Tabbed Slider Approach Section ─── */
const ApproachScrollSection = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [tiltStyle, setTiltStyle] = useState({
    transform: "perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0) scale(1)",
    boxShadow: "0 20px 45px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.02)",
    border: "1px solid rgba(255, 255, 255, 0.45)"
  });

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const box = card.getBoundingClientRect();
    const x = e.clientX - box.left - box.width / 2;
    const y = e.clientY - box.top - box.height / 2;
    const rX = -(y / box.height) * 15; // max 15 degrees tilt
    const rY = (x / box.width) * 15;
    setTiltStyle({
      transform: `perspective(1000px) rotateX(${rX}deg) rotateY(${rY}deg) translateY(-10px) scale(1.02)`,
      boxShadow: `0 30px 60px rgba(0,0,0,0.08), 0 0 20px ${APPROACH_STEPS[activeStep].color}18`,
      border: `1px solid ${APPROACH_STEPS[activeStep].color}26`
    });
  };

  const handleMouseLeave = () => {
    setTiltStyle({
      transform: "perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0) scale(1)",
      boxShadow: "0 20px 45px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.02)",
      border: "1px solid rgba(255, 255, 255, 0.45)"
    });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.05
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: 25 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 90,
        damping: 14
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const step = APPROACH_STEPS[activeStep];

  const handlePrev = () => {
    if (activeStep > 0) {
      setDirection(-1);
      setActiveStep(prev => prev - 1);
    }
  };

  const handleNext = () => {
    if (activeStep < APPROACH_STEPS.length - 1) {
      setDirection(1);
      setActiveStep(prev => prev + 1);
    }
  };

  return (
    <div className="py-5" style={{ background: "linear-gradient(170deg, #f4f8fd 0%, #ffffff 60%, #f0f5fb 100%)", position: "relative" }}>
      {/* Dot-grid background */}
      <div
        style={{
          position: "absolute", inset: 0,
          backgroundImage: "radial-gradient(rgba(29,79,160,0.04) 1.5px, transparent 1.5px)",
          backgroundSize: "28px 28px",
          pointerEvents: "none",
        }}
      />

      <div className="container py-4 position-relative" style={{ zIndex: 2 }}>
        {/* Section Header */}
        <div className="text-center mb-5">
          <div className="d-flex align-items-center justify-content-center gap-3 mb-2">
            <div className="hww-label-line" />
            <span className="hww-label-tag">OUR APPROACH</span>
            <div className="hww-label-line" />
          </div>
          <h2 className="hww-main-title mb-2">
            How We <span className="hww-title-accent">Deliver Excellence</span>
          </h2>
          <p className="hww-subtitle mx-auto">
            Our proven methodology ensures your project is completed on time, within budget, and exceeds expectations.
          </p>
        </div>

        {/* Top Timeline Bar (Steps on top instead of years) */}
        <div className="position-relative mb-5 px-3 px-md-5" style={{ maxWidth: "900px", margin: "0 auto" }}>
          {/* Progress bar background line */}
          <div
            style={{
              position: "absolute",
              top: "25px",
              left: isMobile ? "20px" : "40px",
              right: isMobile ? "20px" : "40px",
              height: "4px",
              background: "#e2e8f0",
              borderRadius: "2px",
              zIndex: 0
            }}
          />
          {/* Active progress fill */}
          {!isMobile && (
            <div
              style={{
                position: "absolute",
                top: "25px",
                left: "40px",
                width: `calc(${(activeStep / (APPROACH_STEPS.length - 1)) * 100}% - 40px)`,
                height: "4px",
                background: "linear-gradient(90deg, #7f22ec, #1b7a43)",
                borderRadius: "2px",
                transition: "width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)",
                zIndex: 1
              }}
            />
          )}

          {/* Stepper nodes */}
          <div className="d-flex justify-content-between align-items-center position-relative" style={{ zIndex: 2 }}>
            {APPROACH_STEPS.map((s, index) => {
              const isActive = index === activeStep;
              const isPassed = index < activeStep;

              return (
                <div
                  key={index}
                  className="d-flex flex-column align-items-center"
                  style={{ cursor: "pointer", width: isMobile ? "45px" : "80px" }}
                  onClick={() => {
                    setDirection(index > activeStep ? 1 : -1);
                    setActiveStep(index);
                  }}
                >
                  {/* Step icon/circle */}
                  <motion.div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: isMobile ? "36px" : "50px",
                      height: isMobile ? "36px" : "50px",
                      borderRadius: isActive ? "12px" : "50%",
                      background: isActive
                        ? `radial-gradient(circle at 30% 30%, ${s.color} 0%, #0e1e36 80%, #060e1b 100%)`
                        : isPassed
                          ? "#e8f5e9"
                          : "#ffffff",
                      border: isActive
                        ? `1px solid ${s.color}`
                        : isPassed
                          ? "2px solid #a8e6cf"
                          : "2px solid #e2e8f0",
                      boxShadow: isActive
                        ? `0 10px 20px ${s.color}33, inset 2px 2px 4px rgba(255,255,255,0.4)`
                        : "0 4px 6px rgba(0,0,0,0.02)",
                      color: isActive
                        ? "#ffffff"
                        : isPassed
                          ? "#1b7a43"
                          : "#a0aec0",
                      transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)"
                    }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <div style={{ transform: isMobile ? "scale(0.8)" : "none" }}>
                      {s.icon}
                    </div>
                  </motion.div>
                  {/* Step label underneath */}
                  <span
                    className="mt-2 text-center text-truncate d-block"
                    style={{
                      fontSize: isMobile ? "0.6rem" : "0.72rem",
                      fontWeight: isActive ? "800" : "600",
                      color: isActive ? s.color : "#718096",
                      transition: "all 0.3s ease",
                      letterSpacing: "0.5px",
                      maxWidth: "100%"
                    }}
                  >
                    {isMobile ? `S${index + 1}` : `Step ${index + 1}`}
                  </span>

                  {/* Step Title Label */}
                  <motion.span
                    className="text-center text-truncate d-block text-uppercase fw-bold"
                    style={{
                      fontSize: isMobile ? "0.5rem" : "0.6rem",
                      letterSpacing: "0.5px",
                      maxWidth: "100%",
                      marginTop: "2px"
                    }}
                    animate={{
                      color: isActive ? s.color : "#a0aec0",
                      y: isActive ? 2 : 0,
                      opacity: isActive ? 1 : 0.65,
                      scale: isActive ? 1.05 : 1
                    }}
                    transition={{ duration: 0.3 }}
                  >
                    {s.title}
                  </motion.span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom Panel Split Layout */}
        <div className="row justify-content-center align-items-center mt-5" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          {/* Left card */}
          <div className="col-12 col-md-5 d-flex justify-content-center mb-4 mb-md-0">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeStep}
                initial={{ opacity: 0, x: -30, rotateY: -15 }}
                animate={{ opacity: 1, x: 0, rotateY: 0 }}
                exit={{ opacity: 0, x: 30, rotateY: 15 }}
                transition={{ duration: 0.4 }}
                style={{
                  width: "100%",
                  maxWidth: "360px",
                  height: "240px",
                  perspective: "1000px"
                }}
              >
                <div
                  className="light-glass-card-shine position-relative pt-4 px-4 pb-3 pt-md-4 px-md-5 pb-md-4 h-100 w-100"
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                  style={{
                    borderRadius: "24px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    ...tiltStyle
                  }}
                >
                  {/* Accent Color Overlay Blob in Top Right */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-20px",
                      right: "-20px",
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      backgroundColor: `${step.color}12`,
                      pointerEvents: "none"
                    }}
                  />

                  <div className="d-flex flex-column h-100 justify-content-between position-relative" style={{ zIndex: 1 }}>
                    {/* Rounded square icon */}
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        width: "54px",
                        height: "54px",
                        borderRadius: "16px",
                        background: `radial-gradient(circle at 30% 30%, ${step.color} 0%, #0e1e36 80%, #060e1b 100%)`,
                        color: "#ffffff",
                        boxShadow: `0 8px 20px ${step.color}22`
                      }}
                    >
                      {step.icon}
                    </div>

                    <div>
                      {/* Badge */}
                      <span
                        className="px-2 py-1 rounded-pill fw-bold text-uppercase mb-2 d-inline-block"
                        style={{
                          background: `${step.color}15`,
                          color: step.color,
                          fontSize: "0.6rem",
                          letterSpacing: "1px"
                        }}
                      >
                        {step.badge}
                      </span>
                      {/* Big step text */}
                      <h2
                        className="fw-bold mb-1"
                        style={{
                          fontSize: "2.1rem",
                          color: "#1b7a43",
                          letterSpacing: "-1px",
                          lineHeight: 1
                        }}
                      >
                        Step 0{activeStep + 1}
                      </h2>
                      {/* Subtitle */}
                      <span
                        style={{
                          fontSize: "0.72rem",
                          fontWeight: "800",
                          color: "#dd6b20",
                          letterSpacing: "1px"
                        }}
                      >
                        {step.subtitle}
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Right text details */}
          <div className="col-12 col-md-7 ps-md-5 text-center text-md-start">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeStep}
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
              >
                {/* Title line decoration */}
                <motion.div
                  variants={itemVariants}
                  className="d-flex align-items-center justify-content-center justify-content-md-start gap-2 mb-3"
                >
                  <div style={{ width: "35px", height: "2px", backgroundColor: "#dd6b20" }} />
                  <h3
                    className="fw-bold m-0"
                    style={{
                      color: "#1b7a43",
                      fontSize: "1.8rem"
                    }}
                  >
                    {step.detailedTitle}
                  </h3>
                </motion.div>

                <motion.p
                  variants={itemVariants}
                  className="text-secondary mb-4"
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.75",
                    color: "#4a5568"
                  }}
                >
                  {step.desc}
                </motion.p>

                {/* Arrows and step status indicator */}
                <motion.div
                  variants={itemVariants}
                  className="d-flex align-items-center justify-content-center justify-content-md-start gap-4"
                >
                  {/* Prev button */}
                  <button
                    onClick={handlePrev}
                    disabled={activeStep === 0}
                    className="btn d-flex align-items-center justify-content-center rounded-circle p-0"
                    style={{
                      width: "45px",
                      height: "45px",
                      border: "1px solid #e2e8f0",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.03)",
                      cursor: activeStep === 0 ? "not-allowed" : "pointer",
                      opacity: activeStep === 0 ? 0.4 : 1,
                      transition: "all 0.2s ease"
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: "translateX(-1px)" }}><polyline points="15 18 9 12 15 6"></polyline></svg>
                  </button>

                  {/* Next button */}
                  <button
                    onClick={handleNext}
                    disabled={activeStep === APPROACH_STEPS.length - 1}
                    className="btn d-flex align-items-center justify-content-center rounded-circle p-0"
                    style={{
                      width: "45px",
                      height: "45px",
                      border: "1px solid #e2e8f0",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.03)",
                      cursor: activeStep === APPROACH_STEPS.length - 1 ? "not-allowed" : "pointer",
                      opacity: activeStep === APPROACH_STEPS.length - 1 ? 0.4 : 1,
                      transition: "all 0.2s ease"
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: "translateX(1px)" }}><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </button>

                  {/* Step Fraction Indicator */}
                  <span
                    style={{
                      fontSize: "0.85rem",
                      fontWeight: "700",
                      color: "#a0aec0",
                      letterSpacing: "1px"
                    }}
                  >
                    0{activeStep + 1} / 0{APPROACH_STEPS.length}
                  </span>
                </motion.div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>

      <style>{`
        .hww-label-line {
          height: 2px; width: 36px;
          background: linear-gradient(90deg, transparent, #7f22ec, transparent);
          border-radius: 2px;
        }
        .hww-label-tag {
          font-family: 'Sora', sans-serif;
          font-size: 12px; font-weight: 800;
          letter-spacing: 3px; color: #7f22ec;
        }
        .hww-main-title {
          font-family: 'Sora', sans-serif;
          font-size: clamp(1.8rem, 4vw, 2.5rem);
          font-weight: 800; color: #0f2441;
          line-height: 1.2; letter-spacing: -0.5px;
        }
        .hww-title-accent {
          background: linear-gradient(135deg, #7f22ec 0%, #1b7a43 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .hww-subtitle {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 1rem; color: #6c7a9c;
          line-height: 1.75; max-width: 580px;
        }
      `}</style>
    </div>
  );
};

const CLIENTS_DATA = [
  { name: "MVP Client", src: "/logos/mvp.png", desc: "Developed a secure minimum viable product portal with microservices architecture." },
  { name: "Auto Branding", src: "/logos/auto.png", desc: "Implemented an automated GPS tracking and advertising system for public transit." },
  { name: "Ahmednagar Municipal Corp", src: "/logos/amc.jpeg", desc: "Designed and built the official AMC civic services portal and grievance management system." },
  { name: "CKI Rubber Technology", src: "/logos/cki.jpeg", desc: "Created an enterprise resource planning (ERP) system to manage rubber manufacturing operations." },
  { name: "General Client Solutions", src: "/logos/logo.png", desc: "Partnered for end-to-end custom web platforms and cloud infrastructure setup." },
  { name: "Digital Ventures", src: "/logos/logo1.png", desc: "Built high-performance landing pages, custom CRM modules, and SEO optimization." },
  { name: "Sapkal Knowledge Hub", src: "/logos/sapkal.jpg", desc: "Developed an online student admission, fee tracking, and academic portal." },
  { name: "Nashik Municipal Corp", src: "/logos/nmc.png", desc: "Created the Law Department Case Management System and garden tree inventory portal." },
  { name: "Nashik Cyclists", src: "/logos/nc.png", desc: "Designed an event registration and membership platform for cycling events." },
  { name: "Dhule Municipal Corp", src: "/logos/dhule.png", desc: "Digitized municipal tax collections and utility billing systems." },
  { name: "CSMC Corporation", src: "/logos/sambhajinagar.jpeg", desc: "Deployed smart city IoT monitoring dashboards and citizen grievance app integrations." },
  { name: "Thane Municipal Corp", src: "/logos/thane.jpg", desc: "Optimized civic data warehouses and public feedback portals." },
  { name: "Venkateshwar Enterprises", src: "/logos/venkateshwar_logo.png", desc: "Created a B2B supply chain inventory management system." },
  { name: "NCF Group", src: "/logos/ncf.png", desc: "Built an e-learning and training management platform for corporate staff." },
  { name: "Durga Agencies", src: "/logos/durga.png", desc: "Implemented a custom point-of-sale (POS) system with real-time stock sync." },
  { name: "Avikam Agency", src: "/logos/avikam_agency.png", desc: "Developed a clean real estate listing and property management database." }
];

const Hexagon = ({ src, x, y, delay = 0, size = 130, isCyan = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.6, y: y + 40 }}
      whileInView={{ opacity: 1, scale: 1, y: y }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ type: "spring", stiffness: 80, damping: 15, delay }}
      style={{
        position: "absolute",
        left: x,
        width: size,
        height: size * 0.866,
        zIndex: isHovered ? 10 : 2,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <motion.div
        animate={{ y: [0, -8, 0] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: delay * 0.5 }}
        whileHover={{ scale: 1.06, rotate: [0, -1.5, 1.5, 0], transition: { duration: 0.3 } }}
        style={{
          width: "100%",
          height: "100%",
          filter: isCyan
            ? (isHovered
              ? "drop-shadow(0 12px 24px rgba(56, 189, 248, 0.5))"
              : "drop-shadow(0 6px 12px rgba(56, 189, 248, 0.25))")
            : (isHovered
              ? "drop-shadow(0 20px 35px rgba(26,80,137,0.22)) drop-shadow(0 8px 16px rgba(0,0,0,0.08))"
              : "drop-shadow(0 12px 24px rgba(26,80,137,0.12)) drop-shadow(0 4px 8px rgba(0,0,0,0.04))"),
          cursor: "pointer",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            background: isCyan
              ? (isHovered
                ? "linear-gradient(135deg, #ffffff 0%, #38bdf8 100%)"
                : "linear-gradient(135deg, #38bdf8 0%, #0d7ec9 100%)")
              : (isHovered
                ? "linear-gradient(135deg, #38bdf8 0%, #1a5089 100%)"
                : "linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)"),
            clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.4s ease",
          }}
        >
          {isCyan ? (
            <div
              style={{
                width: "94%",
                height: "94%",
                background: "radial-gradient(circle at 30% 30%, #56ccf2 0%, #1d4fa0 100%)",
                clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                position: "relative"
              }}
            >
              {/* High-tech internal grid pattern */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: "radial-gradient(rgba(255,255,255,0.18) 1px, transparent 1px)",
                  backgroundSize: "8px 8px",
                  opacity: isHovered ? 0.8 : 0.5,
                  transition: "opacity 0.3s ease"
                }}
              />
              {/* Dynamic pulse highlight */}
              <motion.div
                animate={{
                  transform: ["translate(-100%, -100%) rotate(45deg)", "translate(100%, 100%) rotate(45deg)"]
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                  repeatDelay: 2
                }}
                style={{
                  position: "absolute",
                  width: "150%",
                  height: "20px",
                  background: "rgba(255, 255, 255, 0.15)",
                  transform: "rotate(45deg)"
                }}
              />
            </div>
          ) : (
            <div
              style={{
                width: "95%",
                height: "95%",
                background: "#fcfaf2",
                clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
                overflow: "hidden",
                position: "relative"
              }}
            >
              <img
                src={src}
                alt="Hexagon Graphic"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1)",
                  transform: isHovered ? "scale(1.12) rotate(1deg)" : "scale(1) rotate(0deg)"
                }}
              />
              {/* Subtle ambient overlay to blend with cream background */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(to bottom, rgba(253, 251, 247, 0) 60%, rgba(247, 244, 236, 0.15) 100%)",
                  pointerEvents: "none"
                }}
              />
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};

const Home = () => {
  const [hoveredId, setHoveredId] = useState(null);
  const [stats, setStats] = useState({
    projects: 0,
    clients: 0,
    years: 0,
    solutions: 0,
  });
  const [activeTab, setActiveTab] = useState("interns");
  const [activeCategory, setActiveCategory] = useState("all");
  const [activeServiceIndex, setActiveServiceIndex] = useState(0);
  const [hoveredTechIndex, setHoveredTechIndex] = useState(null);
  const [hoveredCardId, setHoveredCardId] = useState(null);

  useEffect(() => {
    setActiveServiceIndex(0);
  }, [activeCategory]);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [activeClient, setActiveClient] = useState(0);
  const [rotationAngle, setRotationAngle] = useState(-90);

  const handleClientSelect = (index) => {
    let diff = index - activeClient;
    if (diff > 8) diff -= 16;
    if (diff < -8) diff += 16;
    setActiveClient(index);
    setRotationAngle((prev) => prev - diff * 22.5);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      handleClientSelect((activeClient + 1) % 16);
    }, 2000);
    return () => clearInterval(timer);
  }, [activeClient]);

  const rx = isMobile ? 140 : 360;
  const ry = isMobile ? 100 : 190;

  // Scroll-based animations
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  // Refs for intersection observer
  const [aboutRef, aboutInView] = useIntersectionObserver();
  const [statsRef, statsInView] = useIntersectionObserver();
  const [testimonialsRef, testimonialsInView] = useIntersectionObserver();
  const [servicesRef, servicesInView] = useIntersectionObserver();

  // Simulated counter animation
  useEffect(() => {
    if (statsInView) {
      const finalStats = { projects: 100, clients: 70, years: 6, solutions: 4 };
      const duration = 2000;
      const frameDuration = 20; 
      const totalFrames = duration / frameDuration;
      let frame = 0;

      const timer = setInterval(() => {
        frame++;
        const progress = frame / totalFrames;

        setStats({
          projects: Math.floor(progress * finalStats.projects),
          clients: Math.floor(progress * finalStats.clients),
          years: Math.floor(progress * finalStats.years),
          solutions: Math.floor(progress * finalStats.solutions),
        });

        if (frame === totalFrames) {
          clearInterval(timer);
          setStats(finalStats);
        }
      }, frameDuration);

      return () => clearInterval(timer);
    }
  }, [statsInView]);

  // Employee and Intern data (keeping same as original)
  const employees = [
    {
      id: 1,
      name: "Gauri Birari",
      position: "React Js Developer",
      initials: "GB",
      image: "",
      quote: "Reflecting on my journey, I am working as a front-end web developer at Innovative Solutions. It's already been a year since I joined here. When I joined here, I started from scratch, but now after 1 year, I am thrilled to be learning outside of my field here. I am pleased to have the chance to create a project from scratch.",
    },
    {
      id: 2,
      name: "Sakshi Kadave",
      position: "Node Js Developer",
      initials: "SK",
      image: "",
      quote: "I am working as a backend end developer at the Innovative Solutions, and I have been with this company for 1 year now. My experience with this company has been like my second home. All the people around me in the company, especially My Senior sir, who raised me up in all things that I even had no idea about before.",
    },
  ];

  const interns = [
    {
      id: 1,
      name: "Chaitanya Sonaje",
      position: "Full Stack Developer",
      initials: "CS",
      image: "/Team/chaita.png",
      quote: "Working as a Full Stack Developer has been an incredible journey of learning and professional growth. Throughout my experience, I have had the opportunity to work on diverse projects that strengthened my technical expertise and problem-solving skills.",
    },
    {
      id: 2,
      name: "Harshal Deore",
      position: "Project Manager",
      initials: "HD",
      image: "/Team/harshal.jpeg",
      quote: "My journey at Innovative Solutions has been a story of continuous learning, growth, and leadership. Starting as a React Intern, progressing to React Developer, and now serving as a Project Manager, I've had the opportunity to contribute to impactful projects while growing both technically and professionally.",
    },
    {
      id: 3, 
      name: "Kunal Desale",
      position: "Graphics Designer",
      initials: "KD",
      image: "/Team/jayesh.png",
      quote: "I work at Innovative Solutions as a Graphic Designer. Over the year, I have developed a passion for creating designs that effectively communicate ideas and leave a lasting impression. Every project has helped me grow creatively while improving my technical and problem-solving skills.",
    },
    {
      id: 4,
      name: "Dhrumin Bhavsar",
      position: "AI Engineer",
      initials: "DB",
      image: "/Team/dhrumin.jpeg",
      quote: "I am currently interning at Innovative Solutions as an AI Engineer. I've been with the organization for about a month now, and I'm already glad that I chose this path. Getting hands-on exposure to real AI projects so early in my career has been both exciting and deeply rewarding.",
    },
    {
      id: 5,
      name: "Vinayak Patil", 
      position: "AI Engineer",
      initials: "VP",
      image: "/Team/vina.jpeg",
      quote: " I work at Innovative Solutions as an AI Engineer. During my time with the organization, I have been involved in developing AI-based applications and intelligent automation solutions. Working on real-world projects has strengthened my technical knowledge and helped me grow as an AI professional.",
    },
    { 
      id: 6,
      name: " Parth Choudhary ",
      position: "UI/UX Designer",
      initials: "PC",
      image: "/Team/parth.jpeg",
      quote: "I recently joined The Innovative Solutions as a UI/UX Design Intern. Although I have only been with the company for a short time, the experience has been both exciting and educational. It has given me the opportunity to understand professional design workflows and collaborate with a talented team.",
    },
    {
      id: 7,
      name: "Hindraj Pawar",
      position: " Full Stack Developer ",
      initials: "HP",
      image: "/Team/hindraj.jpeg",
      quote: "I work at Innovative Solutions as a Full Stack Developer Intern. My journey in technology started with a curiosity about how applications and websites are built, and over time that curiosity turned into a passion for software development. Every project I work on helps me learn something new and improve my skills",
    },
    {
      id: 8,
      name: "Sneha Tambe",
      position: "Data Analyst",
      initials: "ST",
      image: "/Team/sneha1.jpeg",
      quote: "I work at Innovative Solutions as a Data Analyst. Working with this organization has been an enriching experience where I have developed strong analytical thinking, business understanding, and technical skills. The opportunity to work with real-world datasets has helped me grow professionally and build confidence in solving business problems through data.",
    },
    {
      id: 9,
      name: "Shruti Ganore",
      position: "Business Analyst ",
      initials: "SG",
      image: "",
      quote: "My name is Shruti Balkrishna Ganore, and I work at The Innovative Solutions Nashik as a Business Analyst Intern. I'm glad that I chose this career path to bridge the gap between complex business challenges and technical solutions.",
    },
    {
      id: 10,
      name: "Dnyaneshwar Pawar",
      position: "Graphic Designe", 
      initials: "DP",
      image: "/Team/darshan.png",
      quote: "Hello! I'm Dnyaneshwar Pawar, a passionate Graphic Designer at Innovative Solutions. Over the past 4 months, I've been transforming ideas into compelling visual experiences that connect brands with their audience. Design, for me, is more than aesthetics—it's about creating meaningful communication through creativity.",
    },
    {
      id: 11,
      name: "Dev ManeK ",
      position: "Fullstack Developer",
      initials: "DM",
      image: "/Team/dev.jpeg",
      quote: "Joining The Innovative Solutions has been one of the most valuable milestones in my professional career. From the beginning, I was trusted with challenging projects that allowed me to strengthen both my frontend and backend development skills. The supportive environment and collaborative culture helped me gain practical industry experience while continuously improving my technical knowledge.",
    },
    {
      id: 12,
      name: "Khushal Loha",
      position: " AI/ML Engineer",
      initials: "KL",
      image: "/Team/kushal.jpeg", 
      quote: "As an AI/ML Engineer at Innovative Solutions, I develop intelligent applications using Machine Learning, Deep Learning, and Computer Vision. My work involves building AI models, processing data, deploying ML solutions, and integrating AI capabilities into real-world applications to solve complex business problems.",
    },
    {
      id: 13,
      name: "Neha Gayakwad", 
      position: "AI/ML Engineer",
      initials: "NG",
      image: "/Team/neha.png",
      quote: "My name is Neha Gayakawad, and I joined The Innovative Solutions one month ago. Even within this short period, I have had the opportunity to learn new technologies, understand professional workflows, and work alongside experienced team members. I am grateful to be a part of this organization and look forward to growing my skills.",
    },
      {
      id: 14,
      name: "Purva Patil", 
      position: "Full Stack Developer",
      initials: "PP",
      image: "/Team/purva1.jpeg",
      quote: "My name is Purva Patil, and I work at The  Inovative Solutions  as a Full Stack Developer. Working here has helped me improve my technical knowledge and gain practical experience in modern web development. I enjoy learning new technologies and building efficient, user-friendly applications.",
    },
    {
      id: 15,
      name: "Mrug Rajguru", 
      position: "Human Resource",
      initials: "MR",
      image: "/Team/mrug.jpeg",
      quote: "As a Human Resourse at Innovative Solutions, / work with Employee satisfaction, Employee growth, work culture, Ethics, Recrutiment, Understanding, Unbaised professionalism etc..",
    }, 
    {
      id: 16,
      name: "Kundan Patil", 
      position: "AI/ML Engineer",
      initials: "KP",
      image: "/Team/kundan.jpeg",
      quote: "Working at Innovative Solutions has been an incredible journey of growth and learning. As an AI/ML Engineer, I've had the opportunity to work on various challenging projects that have enhanced my technical skills and problem-solving abilities.",
    }, 
    {
      id: 17,
      name: "Nishant Patil", 
      position: "AI/ML Engineer",
      initials: "NP",
      image: "/Team/nishant.jpeg",
      quote: " I have gained valuable hands-on experience and exposure to professional development practices. I have been actively involved in learning, exploring new technologies, and supporting the team in various tasks.",
    }, 
     {
      id: 18,
      name: "Rutuja Kapse", 
      position: "Fullstack Developer.",
      initials: "RK",
      image: "/Team/rutuja.jpeg ",   
      quote: "I am passionate about building responsive and user-friendly web applications. I enjoy learning new technologies and continuously improving my technical and problem-solving skills. My goal is to build innovative software solutions and grow as a professional in the IT industry.",
    },    
  ];
 
  const currentTestimonials = activeTab === "employees" ? employees : interns;
  const handleTabChange = (tab) => setActiveTab(tab);

  // Technology Stack (keeping same as original)
  const technologies = [
    {
      name: "HTML",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      color: "#E34F26",
    },
    {
      name: "CSS",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      color: "#1572B6",
    },
    {
      name: "Javascript",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      color: "#F7DF1E",
    },
    {
      name: "React JS",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      color: "#61DAFB",
    },
    {
      name: "React Native",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      color: "#61DAFB",
    },
    {
      name: "Node JS",
      icon: "/languages/node.png",
      color: "#47A248",
    },
    {
      name: "PHP",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg",
      color: "#777BB4",
    },
    {
      name: "Spring Boot",
      icon: "/languages/spring.png",
      color: "#777BB4",
    },
    {
      name: "Java",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      color: "#007396",
    },
    {
      name: "MySQL",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      color: "#4479A1",
    },
    {
      name: "MongoDB",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      color: "#47A248",
    },
    {
      name: "Figma",
      icon: "/languages/figma.png",
      color: "#47A248",
    },
    {
      name: "Flutter",
      icon: "/languages/flutter.png",
      color: "#47A248",
    },
    {
      name: "Angular",
      icon: "/languages/angular.png",
      color: "#47A248",
    },
    {
      name: "PostgreSQL",
      icon: "/languages/postgresql.png",
      color: "#47A248",
    },
    {
      name: ".Net",
      icon: "/languages/net.png",
      color: "#47A248",
    },
    {
      name: "Power BI",
      icon: "/languages/power_bi.png",
      color: "#47A248",
    },
    {
      name: "Tableau",
      icon: "/languages/tableau.png",
      color: "#47A248",
    },
  ];

  // Service Data (keeping original colors)
  const serviceData = [
    {
      id: 1,
      img: "https://images.unsplash.com/photo-1547082299-de196ea013d6?w=400&auto=format&fit=crop&q=60",
      title: "Website Design and Development",
      subtitle: "Frontend & Backend Solutions",
      desc: "Crafting responsive, high-performance websites and applications that drive business growth and enhance user experience.",
      icon: "bi-code-slash",
      category: "development",
      color: "#0ea5e9",
      bgColor: "rgba(14, 165, 233, 0.08)"
    },
    {
      id: 2,
      img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&auto=format&fit=crop&q=60",
      title: "Digital Marketing and SEO",
      subtitle: "Data-Driven Strategies",
      desc: "Strategic campaigns that increase your online visibility, engage your target audience, and convert visitors into loyal customers.",
      icon: "bi-graph-up-arrow",
      category: "marketing",
      color: "#8b5cf6",
      bgColor: "rgba(139, 92, 246, 0.08)"
    },
    {
      id: 3,
      img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&auto=format&fit=crop&q=60",
      title: "Business Consultancy",
      subtitle: "Expert IT Guidance",
      desc: "Strategic advisory services to help you navigate the digital landscape, optimize operations, and accelerate business growth.",
      icon: "bi-briefcase",
      category: "consulting",
      color: "#f59e0b",
      bgColor: "rgba(245, 158, 11, 0.08)"
    },
    {
      id: 4,
      img: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400&auto=format&fit=crop&q=60",
      title: "Cyber Security Training",
      subtitle: "Advanced Protection",
      desc: "Comprehensive security solutions that safeguard your digital assets, protect sensitive data, and prevent cyber threats.",
      icon: "bi-shield-lock",
      category: "security",
      color: "#ef4444",
      bgColor: "rgba(239, 68, 68, 0.08)"
    },
    {
      id: 5,
      img: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=400&auto=format&fit=crop&q=60",
      title: "Custom Software Development",
      subtitle: "Custom Enterprise Solutions",
      desc: "Tailored software solutions designed to address your unique business challenges and drive operational efficiency.",
      icon: "bi-cpu",
      category: "development",
      color: "#10b981",
      bgColor: "rgba(16, 185, 129, 0.08)"
    },
    {
      id: 6,
      img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&auto=format&fit=crop&q=60",
      title: "Mobile App Development",
      subtitle: "iOS & Android Apps",
      desc: "Intuitive, feature-rich mobile applications that deliver exceptional user experiences across all devices and platforms.",
      icon: "bi-phone",
      category: "development",
      color: "#ec4899",
      bgColor: "rgba(236, 72, 153, 0.08)"
    },
    {
      id: 7,
      img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&auto=format&fit=crop&q=60",
      title: "Hosting Services",
      subtitle: "Cpanel Dynamic Hosting",
      desc: "Reliable, scalable hosting solutions with 99.9% uptime guarantee and comprehensive technical support for your digital presence.",
      icon: "bi-hdd-stack",
      category: "hosting",
      color: "#6366f1",
      bgColor: "rgba(99, 102, 241, 0.08)"
    },
    {
      id: 8,
      img: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&auto=format&fit=crop&q=60",
      title: "VAPT Audit Services",
      subtitle: "Vulnerability Assessment",
      desc: "Comprehensive security audits to identify vulnerabilities and strengthen your digital infrastructure against cyber threats.",
      icon: "bi-shield-check",
      category: "security",
      color: "#14b8a6",
      bgColor: "rgba(20, 184, 166, 0.08)"
    },
  ];

  const filteredServices = serviceData.filter((service) => {
    if (activeCategory === "all") return true;
    if (activeCategory === "development") return service.category === "development";
    if (activeCategory === "business") return service.category === "marketing" || service.category === "consulting";
    if (activeCategory === "security_hosting") return service.category === "security" || service.category === "hosting";
    return true;
  });

  const currentService = filteredServices[activeServiceIndex] || filteredServices[0] || serviceData[0];

  const serviceCardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.95 },
    visible: (idx) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 70,
        damping: 14,
        delay: idx * 0.08
      }
    })
  };

  const tabContainerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const tabItemVariants = {
    hidden: { opacity: 0, y: 15, scale: 0.92 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15
      }
    }
  };

  const getIconAnimation = (iconName, isTriggered) => {
    if (!isTriggered) return {};
    switch (iconName) {
      case "bi-code-slash":
        return { rotate: [0, 8, -8, 0], transition: { repeat: Infinity, duration: 2, ease: "easeInOut" } };
      case "bi-graph-up-arrow":
        return { y: [0, -4, 0], x: [0, 2, 0], transition: { repeat: Infinity, duration: 2.2, ease: "easeInOut" } };
      case "bi-briefcase":
        return { scale: [1, 1.08, 1], transition: { repeat: Infinity, duration: 2.5, ease: "easeInOut" } };
      case "bi-shield-lock":
        return { scale: [1, 1.05, 1], rotate: [0, 3, -3, 0], transition: { repeat: Infinity, duration: 2.8, ease: "easeInOut" } };
      case "bi-cpu":
        return { rotate: 360, transition: { repeat: Infinity, duration: 8, ease: "linear" } };
      case "bi-phone":
        return { rotate: [0, 10, -10, 0, 10, -10, 0], transition: { repeat: Infinity, duration: 2, ease: "easeInOut", repeatDelay: 1 } };
      case "bi-hdd-stack":
        return { opacity: [0.6, 1, 0.6], transition: { repeat: Infinity, duration: 1.5, ease: "easeInOut" } };
      case "bi-shield-check":
        return { scale: [1, 1.1, 1], transition: { repeat: Infinity, duration: 2, ease: "easeInOut" } };
      default:
        return {};
    }
  };

  return (
    <>
      {/* Modern Hero Section */}
      <motion.div
        className="hero-parallax"
        style={{ y, opacity }}
      >
        <Slider />
      </motion.div>

      {/* Redesigned Honeycomb Cream-Theme About Section */}
      <motion.section
        ref={aboutRef}
        className="about-section py-5 position-relative"
        style={{
          background: "linear-gradient(135deg, #fdfbf7 0%, #f7f4ec 100%)",
          minHeight: "auto",
          overflow: "hidden"
        }}
        initial="hidden"
        animate={aboutInView ? "visible" : "hidden"}
        variants={staggerContainer}
      >
        {/* Geometric background shapes (Soft warm accents) */}
        <div style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 0 }}>
          <div style={{
            position: "absolute", top: "-10%", right: "-10%",
            width: "600px", height: "600px",
            background: "rgba(26,80,137,0.03)",
            transform: "rotate(45deg)",
            borderRadius: "100px",
            filter: "blur(80px)"
          }} />
          <div style={{
            position: "absolute", bottom: "-20%", left: "-10%",
            width: "500px", height: "500px",
            background: "rgba(245,166,35,0.04)",
            transform: "rotate(45deg)",
            borderRadius: "80px",
            filter: "blur(60px)"
          }} />
        </div>

        <Container className="my-2 py-3 position-relative" style={{ zIndex: 1 }}>
          <Row className="align-items-center">

            {/* LEFT COLUMN: Text and Horizontal Lines */}
            <motion.div className="col-lg-6 mb-5 mb-lg-0" variants={slideInLeft}>
              <div style={{ width: "65px", height: "4px", background: "#f5a623", marginBottom: "25px" }} />

              <h6 style={{
                color: "#1a5089",
                fontSize: "13px",
                fontWeight: "800",
                textTransform: "uppercase",
                letterSpacing: "3px",
                marginBottom: "12px",
                fontFamily: "'Inter', sans-serif"
              }}>

              </h6>

              <h2 style={{
                fontSize: "clamp(2.2rem, 4.2vw, 3.4rem)",
                fontWeight: "900",
                color: "#0a1e3d",
                lineHeight: "1.15",
                marginBottom: "25px",
                letterSpacing: "-1px",
                fontFamily: "'Inter', sans-serif"
              }}>
                Transforming Businesses through <br />
                <span style={{
                  background: "linear-gradient(135deg, #1a5089 0%, #3D90D7 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text"
                }}>
                  Innovative IT Solutions
                </span>
              </h2>

              <p style={{
                color: "#334a66",
                fontSize: "14.5px",
                lineHeight: "1.75",
                textAlign: "justify",
                marginBottom: "35px",
                fontWeight: "500"
              }}>
               At Innovative Solutions, we are a dynamic IT company committed to delivering innovative, reliable, and customer-focused technology solutions. We provide a wide range of IT services designed to help businesses improve efficiency, streamline operations, and achieve their goals. <br/>

In today's rapidly evolving digital world, organizations need flexible and advanced technology solutions to remain competitive. Our team focuses on understanding each client's unique requirements and delivering customized, high-quality solutions that are efficient, scalable, and cost-effective. We strive to exceed customer expectations by combining technical expertise, innovation, and a commitment to excellence in every project we undertake.
              </p>

              {/* Glowing horizontal connector lines matching screen-right */}
              <div style={{ display: "flex", flexDirection: "column", gap: "18px", marginBottom: "35px" }}>
                {[120, 180, 240].map((width, i) => (
                  <div key={i} style={{ position: "relative", width: `${width + 16}px`, height: "12px", display: "flex", alignItems: "center" }}>
                    {/* The Line */}
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: width }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.2, delay: i * 0.15, ease: "easeOut" }}
                      style={{
                        height: "2px",
                        background: "linear-gradient(90deg, rgba(26,80,137,0.05) 0%, rgba(26,80,137,0.3) 100%)",
                        position: "absolute",
                        left: 0,
                        overflow: "hidden"
                      }}
                    >
                      {/* Shifting background light highlight */}
                      <motion.div
                        animate={{
                          x: ["-100%", "100%"]
                        }}
                        transition={{
                          duration: 3,
                          repeat: Infinity,
                          ease: "linear",
                          delay: i * 0.4
                        }}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          height: "100%",
                          width: "50%",
                          background: "linear-gradient(90deg, transparent, rgba(56, 189, 248, 0.5), transparent)"
                        }}
                      />
                    </motion.div>

                    {/* Traveling laser particle dot */}
                    <motion.div
                      animate={{
                        left: [0, width + 12],
                        opacity: [0, 1, 1, 0]
                      }}
                      transition={{
                        duration: 2.8,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: i * 0.4
                      }}
                      style={{
                        position: "absolute",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: "#38bdf8",
                        boxShadow: "0 0 8px #38bdf8, 0 0 16px #38bdf8",
                        zIndex: 2,
                        pointerEvents: "none"
                      }}
                    />

                    {/* Fixed dot at the end of the line */}
                    <div style={{ position: "absolute", left: `${width + 8}px`, width: "8px", height: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      {/* Pulsing halo */}
                      <motion.div
                        animate={{
                          scale: [1, 1.6, 1],
                          opacity: [0.3, 0.7, 0.3]
                        }}
                        transition={{
                          duration: 2,
                          repeat: Infinity,
                          ease: "easeInOut",
                          delay: i * 0.3
                        }}
                        style={{
                          position: "absolute",
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          background: "rgba(56, 189, 248, 0.3)",
                          filter: "blur(2px)",
                          zIndex: 0
                        }}
                      />
                      {/* Main node */}
                      <motion.div
                        animate={{
                          scale: [1, 1.15, 1]
                        }}
                        transition={{
                          duration: 2,
                          repeat: Infinity,
                          ease: "easeInOut",
                          delay: i * 0.3
                        }}
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: "#1a5089",
                          boxShadow: "0 0 8px rgba(26,80,137,0.6)",
                          zIndex: 1
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.96 }} style={{ display: "inline-block" }}>
                <NavLink
                  to="/about"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    background: "linear-gradient(135deg, #1a5089 0%, #3D90D7 100%)",
                    borderRadius: "50px",
                    padding: "12px 28px",
                    color: "#ffffff",
                    fontSize: "14.5px",
                    fontWeight: "800",
                    textDecoration: "none",
                    boxShadow: "0 10px 25px rgba(26,80,137,0.35)",
                    letterSpacing: "0.2px",
                  }}
                >
                  Learn More About Us
                </NavLink>
              </motion.div>
            </motion.div>

            {/* RIGHT COLUMN: Hexagonal Honeycomb Cluster */}
            <motion.div className="col-lg-6" variants={slideInRight}>
              <div
                className="hexagon-cluster"
                style={{
                  position: "relative",
                  width: "100%",
                  maxWidth: "530px",
                  height: "320px",
                  margin: "0 auto",
                  flexShrink: 0
                }}
              >
                {/* Image Hexagon 1: Top-Left (Staggered Column 1) */}
                <Hexagon
                  src="https://images.unsplash.com/photo-1531538606174-0f90ff5dce83?w=500&auto=format&fit=crop&q=60"
                  x={130} y={20} delay={0} size={160}
                />

                {/* Image Hexagon 2: Top-Right (Staggered Column 3) */}
                <Hexagon
                  src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500&auto=format&fit=crop&q=60"
                  x={370} y={20} delay={0.5} size={160}
                />

                {/* Image Hexagon 3: Middle-Left (Staggered Column 0) */}
                <Hexagon
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=500&auto=format&fit=crop&q=60"
                  x={10} y={89} delay={1} size={160}
                />

                {/* Image Hexagon 4: Middle-Right (Staggered Column 2) */}
                <Hexagon
                  src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=500&auto=format&fit=crop&q=60"
                  x={250} y={89} delay={1.5} size={160}
                />

                {/* Image Hexagon 5: Bottom-Left (Staggered Column 1) */}
                <Hexagon
                  src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=500&auto=format&fit=crop&q=60"
                  x={130} y={159} delay={2} size={160}
                />

                {/* Image Hexagon 6: Bottom-Right (Staggered Column 3) */}
                <Hexagon
                  src="https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=500&auto=format&fit=crop&q=60"
                  x={370} y={159} delay={2.5} size={160}
                />

                {/* Floating Cyan Accent Hexagon 1 */}
                <Hexagon x={450} y={70} size={55} delay={0.8} isCyan={true} />

                {/* Floating Cyan Accent Hexagon 2 */}
                <Hexagon x={450} y={210} size={55} delay={1.8} isCyan={true} />

                {/* Floating Cyan Accent Hexagon 3 */}
                <Hexagon x={-20} y={135} size={55} delay={2.2} isCyan={true} />
              </div>
            </motion.div>

          </Row>
        </Container>
      </motion.section>

      {/* Core Values Section */}
      <motion.section
        className="core-values-section py-5"
        style={{
          background: "#ffffff",
          position: "relative",
          zIndex: 1,
          borderBottom: "1px solid rgba(0,0,0,0.03)"
        }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={staggerContainer}
      >
        <Container className="py-4">
          <Row className="justify-content-center text-center mb-5">
            <Col lg={8}>
              <h2 style={{
                fontSize: "clamp(2rem, 3.5vw, 2.8rem)",
                fontWeight: "900",
                color: "#0a1e3d",
                lineHeight: "1.2",
                fontFamily: "'Inter', sans-serif"
              }}>
                Why <span style={{
                  background: "linear-gradient(135deg, #1a5089 0%, #3D90D7 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text"
                }}>Choose Us</span> ?
              </h2>
              <div style={{
                width: "60px",
                height: "4px",
                background: "linear-gradient(90deg, #1a5089, #3D90D7)",
                borderRadius: "2px",
                margin: "15px auto 0 auto"
              }} />
            </Col>
          </Row>
          <Row className="justify-content-center text-center g-4">
            {[
              {
                title: "Authenticity",
                desc: "Upfront about strengths, limitations, and transparent timelines.",
                icon: (
                  <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 54C32 54 48 48 48 34V14L32 8L16 14V34C16 48 32 54 32 54Z" fill="#00c853" stroke="#2d3748" strokeWidth="3.5" strokeLinejoin="round" />
                    <path d="M23 29L29 35L41 21" stroke="#ffffff" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M23 29L29 35L41 21" stroke="#2d3748" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )
              },
              {
                title: "Creativity",
                desc: "Creative solutions meeting client needs and quality standards.",
                icon: (
                  <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 12C22 12 19 20 19 29C19 35 23 39 25 43C26.5 45.5 26.5 48.5 26.5 50H37.5C37.5 48.5 37.5 45.5 39 43C41 39 45 35 45 29C45 20 42 12 32 12Z" fill="#ffb300" stroke="#2d3748" strokeWidth="3.5" strokeLinejoin="round" />
                    <path d="M28.5 50H35.5V53H28.5V50Z" fill="#b0bec5" stroke="#2d3748" strokeWidth="3.5" />
                    <path d="M29.5 53H34.5V56H29.5V53Z" fill="#78909c" stroke="#2d3748" strokeWidth="3.5" />
                    <path d="M27 34L32 25L37 34" stroke="#2d3748" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <line x1="32" y1="4" x2="32" y2="8" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                    <line x1="14.3" y1="14.3" x2="17.1" y2="17.1" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                    <line x1="6" y1="29" x2="10" y2="29" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                    <line x1="14.3" y1="43.7" x2="17.1" y2="40.9" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                    <line x1="49.7" y1="14.3" x2="46.9" y2="17.1" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                    <line x1="58" y1="29" x2="54" y2="29" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                    <line x1="49.7" y1="43.7" x2="46.9" y2="40.9" stroke="#2d3748" strokeWidth="3.5" strokeLinecap="round" />
                  </svg>
                )
              },
              {
                title: "Teamwork",
                desc: "We foster teamwork where we sharing resources, experiences, goals.",
                icon: (
                  <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 15C22.6 15 15 22.6 15 32C15 41.4 22.6 49 32 49C41.4 49 49 41.4 49 32C49 22.6 41.4 15 32 15Z" fill="#90caf9" stroke="#2d3748" strokeWidth="3.5" />
                    <circle cx="32" cy="32" r="6" fill="#ffffff" stroke="#2d3748" strokeWidth="3" />
                    <rect x="30" y="9" width="4" height="7" rx="1" fill="#90caf9" stroke="#2d3748" strokeWidth="3.5" />
                    <rect x="30" y="48" width="4" height="7" rx="1" fill="#90caf9" stroke="#2d3748" strokeWidth="3.5" />
                    <rect x="9" y="30" width="7" height="4" rx="1" fill="#90caf9" stroke="#2d3748" strokeWidth="3.5" />
                    <rect x="48" y="30" width="7" height="4" rx="1" fill="#90caf9" stroke="#2d3748" strokeWidth="3.5" />
                    <circle cx="21" cy="30" r="4.5" fill="#29b6f6" stroke="#2d3748" strokeWidth="3" />
                    <path d="M15 43C15 37 19 35.5 21 35.5C23 35.5 27 37 27 43" fill="#29b6f6" stroke="#2d3748" strokeWidth="3" />
                    <circle cx="43" cy="30" r="4.5" fill="#ab47bc" stroke="#2d3748" strokeWidth="3" />
                    <path d="M37 43C37 37 41 35.5 43 35.5C45 35.5 49 37 49 43" fill="#ab47bc" stroke="#2d3748" strokeWidth="3" />
                    <circle cx="32" cy="26" r="5.5" fill="#66bb6a" stroke="#2d3748" strokeWidth="3" />
                    <path d="M25 43C25 36.5 29 33.5 32 33.5C35 33.5 39 36.5 39 43H25Z" fill="#66bb6a" stroke="#2d3748" strokeWidth="3" />
                  </svg>
                )
              },
              {
                title: "Passion",
                desc: "We pride ourselves on dedication and achieving client approval.",
                icon: (
                  <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M47 13C43 13 41 17 41 17C41 17 39 13 35 13C31 13 28 16.5 28 20.5C28 26.5 41 33 41 33C41 33 54 26.5 54 20.5C54 16.5 51 13 47 13Z" fill="#e53935" stroke="#2d3748" strokeWidth="3.5" strokeLinejoin="round" />
                    <rect x="20" y="44" width="14" height="8" fill="#546e7a" stroke="#2d3748" strokeWidth="3.5" />
                    <path d="M22 36V44H32V36" fill="#ffcc80" stroke="#2d3748" strokeWidth="3.5" />
                    <path d="M19 28C19 26 21 26 21 28V36H19V28Z" fill="#ffcc80" stroke="#2d3748" strokeWidth="3" />
                    <path d="M21 27C21 25 23 25 23 27V36H21V27Z" fill="#ffcc80" stroke="#2d3748" strokeWidth="3" />
                    <path d="M23 27C23 25 25 25 25 27V36H23V27Z" fill="#ffcc80" stroke="#2d3748" strokeWidth="3" />
                    <path d="M25 28C25 26 27 26 27 28V36H25V28Z" fill="#ffcc80" stroke="#2d3748" strokeWidth="3" />
                    <path d="M27 31C29 31 31 33 29 35H23" stroke="#2d3748" strokeWidth="3" strokeLinecap="round" />
                  </svg>
                )
              }
            ].map((item, idx) => (
              <Col key={idx} xs={12} sm={6} lg={3} className="d-flex flex-column align-items-center px-4">
                <motion.div
                  variants={fadeInUp}
                  whileHover={{ scale: 1.08 }}
                  transition={{ type: "spring", stiffness: 300, damping: 15 }}
                  style={{
                    width: "110px",
                    height: "110px",
                    borderRadius: "50%",
                    backgroundColor: "#ffe8e2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                    boxShadow: "0 8px 20px rgba(255, 232, 226, 0.4)",
                    border: "1px solid rgba(255, 255, 255, 0.6)",
                    cursor: "pointer"
                  }}
                >
                  {item.icon}
                </motion.div>

                <motion.h4
                  variants={fadeInUp}
                  style={{
                    color: "#0a1e3d",
                    fontSize: "18px",
                    fontWeight: "800",
                    marginBottom: "10px",
                    fontFamily: "'Inter', sans-serif"
                  }}
                >
                  {item.title}
                </motion.h4>

                <motion.p
                  variants={fadeInUp}
                  style={{
                    color: "#556b85",
                    fontSize: "13.5px",
                    lineHeight: "1.6",
                    fontWeight: "500",
                    maxWidth: "240px",
                    margin: 0,
                    fontFamily: "'Inter', sans-serif"
                  }}
                >
                  {item.desc}
                </motion.p>
              </Col>
            ))}
          </Row>
        </Container>
      </motion.section>

      {/* Enhanced Services Section with Original Colors */}
      <motion.section
        ref={servicesRef}
        className="services-section position-relative py-5 overflow-hidden"
        initial="hidden"
        animate={servicesInView ? "visible" : "hidden"}
        variants={staggerContainer}
      >
        {/* Subtle background animation particles */}
        <div className="services-bg-animation">
          {[...Array(6)].map((_, i) => (
            <motion.div
              key={i}
              className={`service-particle particle-${i}`}
              animate={{
                y: [0, -40, 0],
                x: [0, 20, 0],
                opacity: [0.08, 0.25, 0.08],
              }}
              transition={{
                duration: 6 + i,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              style={{
                position: 'absolute',
                left: `${15 + i * 15}%`,
                top: `${20 + (i % 2) * 30}%`,
                width: `${10 + (i % 3) * 6}px`,
                height: `${10 + (i % 3) * 6}px`,
                background: 'rgba(29,79,160,0.06)',
                borderRadius: '50%',
                backdropFilter: 'blur(1px)',
              }}
            />
          ))}
        </div>

        <Container className="py-4 position-relative" style={{ zIndex: 2 }}>
          <motion.div
            className="text-center mb-5"
            variants={tabContainerVariants}
          >
            <motion.h6
              variants={tabItemVariants}
              className="services-subtitle text-primary fw-bold text-uppercase tracking-wider mb-2"
            >
              Our Services
            </motion.h6>
            <motion.h2
              variants={tabItemVariants}
              className="display-6 fw-extrabold mb-3 text-extrabold"
            >
              We Provide <motion.span
                animate={{
                  backgroundPosition: ["0% 50%", "200% 50%"]
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "linear"
                }}
                style={{
                  background: "linear-gradient(90deg, #1d4fa0 0%, #0ea5e9 25%, #10b981 50%, #0ea5e9 75%, #1d4fa0 100%)",
                  backgroundSize: "200% auto",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  display: "inline-block",
                  fontWeight: 900
                }}
              >
                Solutions
              </motion.span> For Your Business
            </motion.h2>
            <motion.p
              variants={tabItemVariants}
              className="text-muted mx-auto"
              style={{ maxWidth: "600px" }}
            >
              Empowering businesses with cutting-edge technology to solve complex
              challenges and drive sustainable growth.
            </motion.p>

            {/* Premium Category Filter Tabs with Sliding Background */}
            <motion.div
              className="d-flex justify-content-center flex-wrap gap-2 mt-4 mb-2"
              variants={tabContainerVariants}
            >
              {[
                { id: "all", label: "All Services" },
                { id: "development", label: "Software & Web" },
                { id: "business", label: "Marketing & Strategy" },
                { id: "security_hosting", label: "Security & Hosting" }
              ].map((tab) => {
                const isActive = activeCategory === tab.id;
                return (
                  <motion.button
                    key={tab.id}
                    className="service-tab-btn"
                    onClick={() => setActiveCategory(tab.id)}
                    variants={tabItemVariants}
                    whileHover={{ scale: 1.05, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      color: isActive ? "#ffffff" : "#4b5a6f",
                      border: isActive ? "1px solid #0ea5e9" : "1px solid rgba(14, 165, 233, 0.08)",
                      background: isActive ? "transparent" : "rgba(255, 255, 255, 0.85)",
                    }}
                  >
                    {tab.label}
                    {isActive && (
                      <motion.div
                        className="tab-indicator-bg"
                        layoutId="activeTabIndicatorBg"
                        style={{
                          position: "absolute",
                          inset: 0,
                          borderRadius: "100px",
                          background: "linear-gradient(135deg, #0ea5e9 0%, #1d4fa0 100%)",
                          zIndex: -1,
                          boxShadow: "0 8px 25px rgba(14, 165, 233, 0.28)"
                        }}
                        transition={{ type: "spring", stiffness: 350, damping: 25 }}
                      />
                    )}
                  </motion.button>
                );
              })}
            </motion.div>
          </motion.div>

          <div className="row mt-5 align-items-center">
            {/* Left Column: Active Service Details */}
            <div className="col-12 col-lg-5 mb-5 mb-lg-0 text-center text-lg-start">
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentService.id}
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 30 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                  className="active-service-details pe-lg-4"
                >
                  <span
                    className="service-badge text-uppercase tracking-wider font-semibold mb-3 px-3 py-1.5 d-inline-block"
                    style={{
                      color: currentService.color,
                      background: `${currentService.color}0a`,
                      border: `1.5px solid ${currentService.color}1e`,
                      borderRadius: "50px",
                      fontSize: "0.76rem",
                      fontWeight: 800,
                      letterSpacing: "1px"
                    }}
                  >
                    {currentService.subtitle}
                  </span>

                  <h3
                    className="fw-bold mb-3"
                    style={{
                      fontFamily: "'Sora', sans-serif",
                      fontSize: "2.3rem",
                      color: "#0a1e3d",
                      fontWeight: 800,
                      letterSpacing: "-0.5px",
                      lineHeight: "1.15"
                    }}
                  >
                    {currentService.title}
                  </h3>

                  <p
                    className="mb-3 text-justify"
                    style={{
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontSize: "1rem",
                      color: "#4a5d73",
                      lineHeight: "1.8",
                      minHeight: "110px",
                      fontWeight: "500"
                    }}
                  >
                    {currentService.desc}
                  </p>

                  <div className="pt-1">
                    <NavLink to="/contact" className="text-decoration-none">
                      <motion.button
                        className="btn d-inline-flex align-items-center gap-2 px-4 py-2.5 fw-bold"
                        style={{
                          background: `linear-gradient(135deg, ${currentService.color} 0%, #004d90 100%)`,
                          color: "#ffffff",
                          borderRadius: "100px",
                          border: "none",
                          boxShadow: `0 10px 25px ${currentService.color}45`,
                          fontSize: "15px",
                          letterSpacing: "0.2px"
                        }}
                        whileHover="hover"
                        whileTap={{ scale: 0.96 }}
                        variants={{
                          hover: { scale: 1.05, y: -2, boxShadow: `0 15px 30px ${currentService.color}60` }
                        }}
                      >
                        Get Started
                        <motion.span
                          variants={{
                            hover: { x: 4 }
                          }}
                          transition={{ type: "spring", stiffness: 300, damping: 15 }}
                          style={{ display: "inline-flex" }}
                        >
                          <ChevronRight size={18} />
                        </motion.span>
                      </motion.button>
                    </NavLink>
                  </div>
                </motion.div>
              </AnimatePresence>

              {/* Navigation controls */}
              {filteredServices.length > 1 && (
                <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-3 mt-3">
                  <motion.button
                    onClick={() => {
                      setActiveServiceIndex((prev) => (prev - 1 + filteredServices.length) % filteredServices.length);
                    }}
                    className="nav-arrow-btn d-flex align-items-center justify-content-center"
                    aria-label="Previous Service"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.9 }}
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      border: "1.5px solid rgba(15, 36, 65, 0.12)",
                      background: "#ffffff",
                      color: "#0f2441",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.02)"
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="19" y1="12" x2="5" y2="12"></line>
                      <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                  </motion.button>

                  <motion.button
                    onClick={() => {
                      setActiveServiceIndex((prev) => (prev + 1) % filteredServices.length);
                    }}
                    className="nav-arrow-btn d-flex align-items-center justify-content-center"
                    aria-label="Next Service"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.9 }}
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      border: "1.5px solid rgba(15, 36, 65, 0.12)",
                      background: "#ffffff",
                      color: "#0f2441",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.02)"
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </motion.button>

                  <span
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: "#64748b",
                      letterSpacing: "0.5px",
                      marginLeft: "10px"
                    }}
                  >
                    {activeServiceIndex + 1 < 10 ? `0${activeServiceIndex + 1}` : activeServiceIndex + 1} / {filteredServices.length < 10 ? `0${filteredServices.length}` : filteredServices.length}
                  </span>
                </div>
              )}
            </div>

            {/* Right Column: Sliding Cards Viewport */}
            <div className="col-12 col-lg-7 overflow-hidden py-3">
              <div
                className="services-slider-viewport"
                style={{
                  width: "100%",
                  overflow: "hidden",
                  padding: "15px 5px"
                }}
              >
                <motion.div
                  className="d-flex gap-4"
                  animate={{
                    x: -activeServiceIndex * (isMobile ? 290 : 320)
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 150,
                    damping: 22
                  }}
                  style={{
                    width: "max-content",
                    display: "flex"
                  }}
                >
                  {filteredServices.map((service, index) => {
                    const isActive = index === activeServiceIndex;
                    const cardLocalVariants = {
                      hidden: { opacity: 0, y: 50, scale: 0.95 },
                      visible: {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        transition: {
                          type: "spring",
                          stiffness: 70,
                          damping: 14,
                          delay: index * 0.08
                        }
                      },
                      hover: {
                        y: isActive ? -5 : -12,
                        scale: isActive ? 1.02 : 1.03,
                        borderColor: service.color,
                        transition: {
                          type: "spring",
                          stiffness: 300,
                          damping: 20
                        }
                      },
                      tap: {
                        scale: 0.98
                      }
                    };
                    return (
                      <motion.div
                        key={service.id}
                        onClick={() => setActiveServiceIndex(index)}
                        className={`service-card-premium ${isActive ? "active" : ""}`}
                        variants={cardLocalVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-50px" }}
                        whileHover="hover"
                        whileTap="tap"
                        style={{
                          width: isMobile ? "280px" : "300px",
                          height: "340px",
                          background: isActive ? "linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)" : "rgba(255, 255, 255, 0.95)",
                          border: isActive ? `1px solid rgba(255, 255, 255, 0.2)` : "1px solid rgba(15, 36, 65, 0.08)",
                          borderRadius: "28px",
                          padding: 0,
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          opacity: isActive ? 1 : 0.75,
                          position: "relative",
                          overflow: "hidden",
                          transition: "opacity 0.3s ease, background 0.3s ease, border-color 0.3s ease"
                        }}
                      >
                        {/* Premium diagonal hover sweep shine */}
                        <motion.div
                          variants={{
                            hover: { x: ["-100%", "100%"] }
                          }}
                          transition={{
                            duration: 1.2,
                            ease: "easeInOut"
                          }}
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                            transform: "skewX(-25deg)",
                            zIndex: 5,
                            pointerEvents: "none"
                          }}
                        />

                        {/* Top-half Stock Image */}
                        <div
                          style={{
                            width: "100%",
                            height: "165px",
                            overflow: "hidden",
                            position: "relative",
                            borderRadius: "26px 26px 0 0"
                          }}
                        >
                          <motion.img
                            src={service.img}
                            alt={service.title}
                            className="service-card-image"
                            variants={{
                              hover: { scale: 1.1 }
                            }}
                            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover"
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              inset: 0,
                              background: isActive
                                ? "linear-gradient(to bottom, rgba(14, 165, 233, 0) 40%, #0369a1 98%)"
                                : "linear-gradient(to bottom, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0.95) 98%)",
                              transition: "all 0.3s ease"
                            }}
                          />
                        </div>

                        {/* Floating Icon Container */}
                        <motion.div
                          className="d-flex align-items-center justify-content-center icon-element"
                          variants={{
                            hover: { scale: 1.16, rotate: 8, y: -3 }
                          }}
                          transition={{ type: "spring", stiffness: 300, damping: 15 }}
                          style={{
                            position: "absolute",
                            top: "137px",
                            right: "24px",
                            zIndex: 10,
                            width: "56px",
                            height: "56px",
                            borderRadius: "18px",
                            background: isActive ? "rgba(255, 255, 255, 0.15)" : "#ffffff",
                            backdropFilter: isActive ? "blur(8px)" : "none",
                            border: isActive ? "1px solid rgba(255, 255, 255, 0.3)" : `1px solid ${service.color}22`,
                            color: isActive ? "#ffffff" : service.color,
                            fontSize: "1.6rem",
                            transition: "all 0.3s ease",
                            boxShadow: isActive
                              ? "0 8px 20px rgba(0, 0, 0, 0.2)"
                              : `0 8px 20px ${service.color}15`
                          }}
                        >
                          <i className={`${service.icon}`} />
                        </motion.div>

                        {/* Card Content Container */}
                        <div
                          style={{
                            padding: "1.25rem 1.5rem 1.5rem 1.5rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            flexGrow: 1,
                            position: "relative"
                          }}
                        >
                          <div>
                            <span
                              style={{
                                fontFamily: "'Plus Jakarta Sans', sans-serif",
                                fontSize: "0.75rem",
                                fontWeight: 700,
                                color: isActive ? "rgba(255, 255, 255, 0.7)" : service.color,
                                letterSpacing: "0.8px",
                                textTransform: "uppercase",
                                display: "block",
                                marginBottom: "0.5rem"
                              }}
                            >
                              {service.subtitle}
                            </span>

                            <h4
                              style={{
                                fontFamily: "'Sora', sans-serif",
                                fontSize: "1.15rem",
                                fontWeight: 700,
                                color: isActive ? "#ffffff" : "#0f2441",
                                lineHeight: "1.4",
                                margin: 0
                              }}
                            >
                              {service.title}
                            </h4>
                          </div>

                          {/* Interactive small indicator arrow */}
                          <div
                            className="d-flex align-items-center justify-content-between mt-3"
                            style={{
                              color: isActive ? "#ffffff" : service.color,
                              fontWeight: 600,
                              fontSize: "0.85rem"
                            }}
                          >
                            <span style={{ opacity: isActive ? 0.9 : 0.7 }}>
                              {isActive ? "Active Service" : "Click to view"}
                            </span>
                            <motion.span
                              variants={{
                                hover: { x: 5 }
                              }}
                              transition={{ type: "spring", stiffness: 300, damping: 12 }}
                              style={{ display: "inline-flex" }}
                            >
                              <ChevronRight
                                size={16}
                                style={{
                                  transform: isActive ? "rotate(90deg)" : "none",
                                  transition: "transform 0.3s ease"
                                }}
                              />
                            </motion.span>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </motion.div>
              </div>
            </div>
          </div>
        </Container>

        <style>{`
          .services-section {
            background: linear-gradient(180deg, #ffffff 0%, #f4f6fb 50%, #ffffff 100%) !important;
            padding: 90px 0;
          }
          .services-subtitle {
            font-family: 'Sora', sans-serif;
            letter-spacing: 2px;
            font-size: 13px;
          }
          
          /* Custom Tabs */
          .service-tab-btn {
            border: 1px solid rgba(29, 79, 160, 0.08);
            padding: 10px 24px;
            font-family: 'Sora', sans-serif;
            font-size: 14px;
            font-weight: 700;
            border-radius: 100px;
            cursor: pointer;
            position: relative;
            transition: color 0.3s ease, border-color 0.3s ease;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .service-tab-btn:hover {
            color: #1d4fa0 !important;
            border-color: rgba(29, 79, 160, 0.25) !important;
          }

          .nav-arrow-btn:hover {
            background: #1d4fa0 !important;
            border-color: #1d4fa0 !important;
            color: #ffffff !important;
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(29, 79, 160, 0.2);
          }

           .service-card-premium:not(.active):hover {
            border-color: rgba(15, 36, 65, 0.2) !important;
            opacity: 0.95 !important;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05) !important;
          }

          .service-card-premium:hover .service-card-image {
            transform: scale(1.08);
          }

          .service-card-premium:hover .icon-element {
            transform: scale(1.08) rotate(5deg);
          }
          
          .icon-element {
            transition: transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          }
        `}</style>
      </motion.section>

      {/* Stats Section with Premium White Theme and Animated Color-coded Cards */}
      <motion.section
        ref={statsRef}
        className="stats-section py-5 position-relative overflow-hidden"
        style={{
          background: "#ffffff",
          color: "#0f2441",
        }}
        initial="hidden"
        animate={statsInView ? "visible" : "hidden"}
        variants={staggerContainer}
      >
        <style>{`
          .stat-card-premium {
            background: rgba(245, 246, 248, 0.65);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            border: 1px solid rgba(255, 255, 255, 0.85);
            border-radius: 24px;
            padding: 2.5rem 1.5rem;
            box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.015);
            transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            height: 100%;
          }
          .stat-card-premium:hover {
            background: rgba(255, 255, 255, 0.88);
            border-color: var(--accent-color) !important;
            box-shadow: 0 15px 35px rgba(15, 23, 42, 0.05) !important;
          }
          .stat-icon-container {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            background: var(--bg-color);
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--accent-color);
            transition: all 0.4s ease;
          }
          .stat-card-premium:hover .stat-icon-container {
            background: var(--gradient-color);
            color: #ffffff;
            transform: scale(1.15) rotate(8deg);
          }
          .stat-number {
            font-family: 'Outfit', sans-serif;
            font-size: clamp(2rem, 3.5vw, 2.75rem);
            font-weight: 800;
            line-height: 1.2;
            background: var(--gradient-color);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .stat-label {
            font-family: 'Plus Jakarta Sans', sans-serif;
            font-size: 0.76rem;
            font-weight: 700;
            color: #64748b;
            letter-spacing: 1.2px;
            text-transform: uppercase;
            text-align: center;
            transition: color 0.3s ease;
          }
          .stat-card-premium:hover .stat-label {
            color: #0f2441;
          }

          /* ===== Live Rocket Animation ===== */
          @keyframes rocketLaunch {
            0%   { transform: translateY(0px) translateX(0px) rotate(-45deg); opacity: 1; }
            65%  { transform: translateY(-30px) translateX(30px) rotate(-45deg); opacity: 1; }
            66%  { opacity: 0; }
            67%  { transform: translateY(18px) translateX(-18px) rotate(-45deg); opacity: 0; }
            100% { transform: translateY(0px) translateX(0px) rotate(-45deg); opacity: 1; }
          }
          @keyframes flameFlicker {
            0%,100% { transform: scaleY(1) scaleX(1); opacity: 1; }
            25%      { transform: scaleY(1.3) scaleX(0.8); opacity: 0.9; }
            50%      { transform: scaleY(0.85) scaleX(1.1); opacity: 1; }
            75%      { transform: scaleY(1.1) scaleX(0.9); opacity: 0.85; }
          }
          @keyframes trailFade {
            0%   { opacity: 0.7; height: 14px; }
            50%  { opacity: 0.3; height: 22px; }
            100% { opacity: 0; height: 4px; }
          }
          @keyframes exhaustGlow {
            0%,100% { box-shadow: 0 0 6px 2px rgba(251, 146, 60, 0.6); }
            50%      { box-shadow: 0 0 14px 6px rgba(251, 191, 36, 0.85); }
          }
          .rocket-wrapper {
            position: relative;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .rocket-svg {
            animation: rocketLaunch 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            filter: drop-shadow(0 0 7px rgba(14, 165, 233, 0.65));
          }
          .rocket-flame {
            position: absolute;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%) rotate(-45deg) translateY(10px) translateX(10px);
            width: 8px;
            border-radius: 0 0 6px 6px;
            background: linear-gradient(to bottom, #fbbf24, #f97316, transparent);
            animation: flameFlicker 0.5s ease-in-out infinite, trailFade 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
          }
          .rocket-glow {
            position: absolute;
            inset: -6px;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(14,165,233,0.25) 0%, transparent 70%);
            animation: exhaustGlow 2.5s ease-in-out infinite;
          }
        `}</style>

        {/* Animated background particles */}
        <div className="stats-bg-animation">
          {[...Array(25)].map((_, i) => (
            <motion.div
              key={i}
              className="particle"
              animate={{
                y: [0, -120, 0],
                opacity: [0, 0.7, 0],
              }}
              transition={{
                duration: 4 + Math.random() * 3,
                repeat: Infinity,
                delay: Math.random() * 2,
              }}
              style={{
                position: 'absolute',
                left: `${Math.random() * 100}%`,
                top: '100%',
                width: `${3 + Math.random() * 3}px`,
                height: `${3 + Math.random() * 3}px`,
                background: i % 2 === 0 ? 'rgba(127, 34, 236, 0.18)' : 'rgba(27, 122, 67, 0.15)',
                borderRadius: '50%',
              }}
            />
          ))}
        </div>

        <div className="container position-relative">
          <div className="row text-center g-4">
            {[
              {
                value: stats.projects,
                label: "Projects Completed",
                suffix: "+",
                icon: (
                  <div className="rocket-wrapper">
                    <div className="rocket-glow" />
                    <svg
                      className="rocket-svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 2C12 2 7 7 7 13H17C17 7 12 2 12 2Z" fill="#0ea5e9" />
                      <circle cx="12" cy="10" r="2" fill="white" fillOpacity="0.9" />
                      <path d="M7 13L4 16L7 16Z" fill="#2563eb" />
                      <path d="M17 13L20 16L17 16Z" fill="#2563eb" />
                      <rect x="10" y="13" width="4" height="3" rx="1" fill="#1d4ed8" />
                    </svg>
                    <div className="rocket-flame" style={{ height: '14px' }} />
                    <div className="rocket-flame" style={{ height: '9px', width: '5px', opacity: 0.7, animationDelay: '0.12s' }} />
                  </div>
                ),
                iconAnim: {},
                isRocket: true,
                color: "#0ea5e9",
                bgColor: "rgba(14, 165, 233, 0.08)",
                hoverGradient: "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)"
              },
              {
                value: stats.clients,
                label: "Satisfied Clients",
                suffix: "+",
                icon: <FaUsers size={26} />,
                iconAnim: { scale: [1, 1.08, 1], transition: { repeat: Infinity, duration: 2.5, ease: "easeInOut" } },
                color: "#8b5cf6", // Purple/Violet
                bgColor: "rgba(139, 92, 246, 0.08)",
                hoverGradient: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)"
              },
              {
                value: stats.years,
                label: "Years Experience",
                suffix: "+",
                icon: <FaAward size={26} />,
                iconAnim: { rotate: [0, 8, -8, 0], transition: { repeat: Infinity, duration: 3, ease: "easeInOut" } },
                color: "#f59e0b", // Amber/Gold
                bgColor: "rgba(245, 158, 11, 0.08)",
                hoverGradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
              },
              {
                value: stats.solutions,
                label: "Core Solutions",
                suffix: "+",
                icon: <FaLightbulb size={26} />,
                iconAnim: { opacity: [0.6, 1, 0.6], transition: { repeat: Infinity, duration: 1.8, ease: "easeInOut" } },
                color: "#10b981", // Emerald Green
                bgColor: "rgba(16, 185, 129, 0.08)",
                hoverGradient: "linear-gradient(135deg, #10b981 0%, #047857 100%)"
              },
            ].map((stat, index) => (
              <div
                key={index}
                className="col-6 col-md-3"
              >
                <motion.div
                  variants={fadeInUp}
                  custom={index}
                  style={{ height: "100%" }}
                >
                  <motion.div
                    className="stat-card-premium"
                    animate={{
                      y: [0, -8, 0],
                    }}
                    transition={{
                      y: {
                        repeat: Infinity,
                        repeatType: "reverse",
                        duration: 3.5 + index * 0.5,
                        ease: "easeInOut"
                      }
                    }}
                    whileHover={{
                      y: -12,
                      scale: 1.05,
                      transition: { duration: 0.3 }
                    }}
                    style={{
                      "--accent-color": stat.color,
                      "--bg-color": stat.bgColor,
                      "--gradient-color": stat.hoverGradient,
                    }}
                  >
                    <motion.div
                      className="stat-icon-container mb-3"
                      animate={stat.isRocket ? {} : stat.iconAnim}
                      style={stat.isRocket ? { overflow: 'visible', background: stat.bgColor } : {}}
                    >
                      {stat.icon}
                    </motion.div>

                    <motion.h3
                      className="stat-number mb-1"
                      initial={{ scale: 0 }}
                      animate={statsInView ? { scale: 1 } : { scale: 0 }}
                      transition={{ delay: index * 0.15, duration: 0.8, type: "spring" }}
                    >
                      {stat.value}{stat.suffix}
                    </motion.h3>

                    <p className="stat-label mb-0">
                      {stat.label}
                    </p>
                  </motion.div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Technology Stack Section - HORIZONTAL SCROLLING */}
      <div
        className="py-5 position-relative overflow-hidden"
        style={{ background: "#ffffff" }}
      >
        <style>{`
          @keyframes gridMove {
            0% {
              background-position: 0 0;
            }
            100% {
              background-position: 28px 28px;
            }
          }
          .tech-stack-grid-bg {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: radial-gradient(rgba(46, 125, 50, 0.04) 1.5px, transparent 1.5px);
            background-size: 28px 28px;
            opacity: 0.7;
            pointer-events: none;
            z-index: 0;
            animation: gridMove 20s linear infinite;
          }
        `}</style>
        <div className="tech-stack-grid-bg" />

        {/* Ambient Blur Background Blobs */}
        <motion.div
          style={{
            position: "absolute",
            width: "350px",
            height: "350px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(76, 175, 80, 0.12) 0%, rgba(255, 255, 255, 0) 70%)",
            top: "10%",
            left: "-100px",
            filter: "blur(45px)",
            pointerEvents: "none",
            zIndex: 0
          }}
          animate={{
            x: [0, 50, 0],
            y: [0, -30, 0],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          style={{
            position: "absolute",
            width: "400px",
            height: "400px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(33, 150, 243, 0.08) 0%, rgba(255, 255, 255, 0) 70%)",
            bottom: "10%",
            right: "-100px",
            filter: "blur(55px)",
            pointerEvents: "none",
            zIndex: 0
          }}
          animate={{
            x: [0, -60, 0],
            y: [0, 40, 0],
          }}
          transition={{
            duration: 12,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />

        <div className="container py-5 position-relative" style={{ zIndex: 1 }}>
          <div className="text-center mb-5 d-flex flex-column align-items-center">
            <motion.span
              className="px-3 py-1 mb-3 rounded-pill fw-bold"
              style={{
                background: "rgba(46, 125, 50, 0.08)",
                border: "1px solid rgba(46, 125, 50, 0.18)",
                color: "#2e7d32",
                fontSize: "0.75rem",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                letterSpacing: "1.5px",
                display: "inline-block",
                boxShadow: "0 4px 12px rgba(46, 125, 50, 0.03)"
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              animate={{
                scale: [1, 1.05, 1],
              }}
              transition={{
                y: { duration: 0.6 },
                opacity: { duration: 0.6 },
                scale: { repeat: Infinity, duration: 3, ease: "easeInOut" }
              }}
            >
              OUR TECH STACK
            </motion.span>
            <motion.h2
              className="fw-bold mb-3"
              style={{
                color: "#0f2441",
                fontFamily: "'Outfit', sans-serif",
                fontSize: "clamp(2rem, 4.5vw, 3rem)",
                fontWeight: 800,
                letterSpacing: "-0.5px"
              }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.15 }}
            >
              Proven & Modern{" "}
              <motion.span
                animate={{
                  backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                style={{
                  background: "linear-gradient(135deg, #2e7d32 0%, #10b981 50%, #0284c7 100%)",
                  backgroundSize: "200% auto",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  display: "inline-block"
                }}
              >
                Tech Stack
              </motion.span>
            </motion.h2>
            <motion.p
              className="text-muted"
              style={{
                fontSize: "1.02rem",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                maxWidth: "600px",
                lineHeight: "1.6"
              }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.25 }}
            >
              Empowering businesses with cutting-edge technologies and scalable digital solutions.
            </motion.p>
          </div>

          <div className="py-3">
            <Marquee
              pauseOnHover
              speed={80} 
              gradient={true}
              gradientColor={[255, 255, 255]}
            >
              {technologies.map((tech, index) => {
                const isHovered = hoveredTechIndex === index;
                const dynamicColor = tech.color || "#2e7d32";

                return (
                  <motion.div
                    key={index}
                    onMouseEnter={() => setHoveredTechIndex(index)}
                    onMouseLeave={() => setHoveredTechIndex(null)}
                    className="p-4 mx-3 d-flex flex-column align-items-center justify-content-between"
                    whileHover={{
                      y: -12,
                      scale: 1.06,
                    }}
                    transition={{
                      type: "spring",
                      stiffness: 400,
                      damping: 25
                    }}
                    style={{
                      width: "160px",
                      height: "160px",
                      borderRadius: "20px",
                      background: isHovered ? "rgba(255, 255, 255, 0.95)" : "rgba(245, 246, 248, 0.65)",
                      backdropFilter: "blur(12px)",
                      WebkitBackdropFilter: "blur(12px)",
                      border: isHovered
                        ? `1px solid ${dynamicColor}55`
                        : "1px solid rgba(255, 255, 255, 0.85)",
                      boxShadow: isHovered
                        ? `0 15px 35px ${dynamicColor}25, 0 0 0 1px ${dynamicColor}15`
                        : "0 8px 32px 0 rgba(0, 0, 0, 0.015)",
                      cursor: "pointer",
                      marginBottom: "15px",
                      marginTop: "15px",
                      position: "relative",
                      overflow: "hidden",
                      zIndex: isHovered ? 2 : 1
                    }}
                  >
                    {/* Diagonal light sweep shine effect on hover */}
                    <motion.div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "-100%",
                        width: "60%",
                        height: "100%",
                        background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)",
                        transform: "skewX(-25deg)",
                        pointerEvents: "none",
                        zIndex: 3
                      }}
                      animate={isHovered ? { left: "150%" } : { left: "-100%" }}
                      transition={{ duration: 0.75, ease: "easeInOut" }}
                    />

                    <motion.div
                      className="d-flex align-items-center justify-content-center"
                      animate={{
                        rotate: isHovered ? [0, 8, -4, 0] : 0,
                        scale: isHovered ? 1.12 : 1,
                      }}
                      transition={{ duration: 0.4 }}
                      style={{
                        height: "80px",
                        width: "100%",
                        transformOrigin: "center"
                      }}
                    >
                      <img
                        src={tech.icon}
                        alt={tech.name}
                        style={{
                          maxHeight: "70px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </motion.div>
                    <h6
                      className="mb-0 text-center fw-bold text-uppercase"
                      style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontSize: "0.72rem",
                        letterSpacing: "0.5px",
                        lineHeight: "1.4",
                        color: isHovered ? dynamicColor : "#556b85",
                        transition: "color 0.3s ease",
                        marginTop: "auto"
                      }}
                    >
                      {tech.name}
                    </h6>
                  </motion.div>
                );
              })}
            </Marquee>
          </div>
        </div>
      </div>

      <IndustriesSection />

      {/* ── Scroll-Linked How We Work Section ── */}
      <ApproachScrollSectionNew />

      {/* Call to Action Section - Redesigned to Premium Space Glassmorphism */}
      <motion.div
        className="py-5 position-relative overflow-hidden"
        style={{
          background: "radial-gradient(circle at 50% 50%, #0e172a 0%, #070a13 100%)",
          minHeight: "400px",
          display: "flex",
          alignItems: "center"
        }}
        initial="hidden"
        whileInView="visible"
        variants={staggerContainer}
        viewport={{ once: true }}
      >
        {/* Deep Ambient Glows */}
        <motion.div
          style={{
            position: "absolute",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(127, 34, 236, 0.08) 0%, rgba(255, 255, 255, 0) 70%)",
            top: "-150px",
            left: "-100px",
            filter: "blur(60px)",
            pointerEvents: "none"
          }}
          animate={{
            x: [0, 40, 0],
            y: [0, -30, 0],
          }}
          transition={{
            duration: 12,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          style={{
            position: "absolute",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(27, 122, 67, 0.06) 0%, rgba(255, 255, 255, 0) 70%)",
            bottom: "-150px",
            right: "-100px",
            filter: "blur(60px)",
            pointerEvents: "none"
          }}
          animate={{
            x: [0, -40, 0],
            y: [0, 30, 0],
          }}
          transition={{
            duration: 14,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />

        {/* Rising Water Bubbles Background Effect */}
        <div style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none" }}>
          {[...Array(15)].map((_, i) => (
            <motion.div
              key={i}
              animate={{
                y: [600, -100],
                x: [0, Math.sin(i) * 30, 0],
                opacity: [0, 0.4, 0],
                scale: [1, 1.2, 0.8]
              }}
              transition={{
                duration: 6 + Math.random() * 6,
                repeat: Infinity,
                delay: Math.random() * 5,
                ease: "easeInOut"
              }}
              style={{
                position: 'absolute',
                left: `${Math.random() * 100}%`,
                bottom: '-20px',
                width: `${10 + Math.random() * 20}px`,
                height: `${10 + Math.random() * 20}px`,
                background: 'radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.02) 70%)',
                borderRadius: '50%',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                boxShadow: 'inset 0 2px 4px rgba(255, 255, 255, 0.1)'
              }}
            />
          ))}
        </div>

        <div className="container position-relative py-4" style={{ zIndex: 1 }}>
          <motion.div
            className="p-4 p-md-5 mx-auto"
            style={{
              maxWidth: "1000px",
              background: "rgba(255, 255, 255, 0.02)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              borderRadius: "32px",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              boxShadow: "0 30px 60px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.05)"
            }}
            variants={fadeInUp}
            whileHover={{
              boxShadow: "0 35px 70px rgba(0,0,0,0.5), 0 0 30px rgba(127, 34, 236, 0.05)",
              borderColor: "rgba(255, 255, 255, 0.12)"
            }}
            transition={{ duration: 0.3 }}
          >
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-7 text-center text-lg-start mb-4 mb-lg-0">
                <div className="d-inline-flex align-items-center gap-2 px-3 py-1 mb-3 rounded-pill" style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}>
                  <span className="d-inline-block rounded-circle animate-pulse" style={{ width: "8px", height: "8px", background: "#34d399" }} />
                  <span style={{ color: "#94a3b8", fontFamily: "'Outfit', sans-serif", fontSize: "0.75rem", fontWeight: "700", letterSpacing: "1.5px", textTransform: "uppercase" }}>
                    Get Started Now
                  </span>
                </div>

                <h2 className="fw-bold mb-3 text-white" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: "800", fontSize: "3.2rem", letterSpacing: "-1px", lineHeight: "1.15" }}>
                  Ready to Transform <br className="d-none d-md-inline" />Your <span style={{ background: "linear-gradient(135deg, #a78bfa 0%, #34d399 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>Business?</span>
                </h2>

                <p className="mb-4" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: "1.05rem", color: "#94a3b8", lineHeight: "1.7" }}>
                  Let's discuss how our innovative solutions can help your business grow and achieve new heights in the digital landscape.
                </p>

                {/* Checklist of value points */}
                <div className="d-flex flex-wrap gap-x-4 gap-y-2 justify-content-center justify-content-lg-start" style={{ color: "#cbd5e1", fontSize: "0.88rem" }}>
                  <div className="d-flex align-items-center gap-2 me-4">
                    <CheckCircleFill className="text-success" size={16} />
                    <span>Free Consultations</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 me-4">
                    <CheckCircleFill className="text-success" size={16} />
                    <span>Expert Developers</span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <CheckCircleFill className="text-success" size={16} />
                    <span>Agile Methodology</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-5 text-center text-lg-end d-flex flex-column align-items-center align-items-lg-end justify-content-center">
                <motion.div
                  className="position-relative d-inline-block"
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {/* Subtle outer glowing aura for the button */}
                  <div
                    style={{
                      position: "absolute",
                      inset: "-4px",
                      background: "linear-gradient(135deg, #7f22ec 0%, #1b7a43 100%)",
                      borderRadius: "18px",
                      filter: "blur(12px)",
                      opacity: 0.5,
                      zIndex: 0
                    }}
                  />

                  <NavLink
                    className="btn btn-lg text-white fw-bold px-5 py-3 text-decoration-none position-relative d-inline-flex align-items-center justify-content-center gap-2"
                    style={{
                      background: "linear-gradient(135deg, #7f22ec 0%, #1b7a43 100%)",
                      border: "none",
                      borderRadius: "14px",
                      fontSize: "1.1rem",
                      zIndex: 1,
                      boxShadow: "0 10px 25px rgba(127, 34, 236, 0.25)"
                    }}
                    to="/contact"
                  >
                    Contact Us Today
                    <ArrowRight size={20} />
                  </NavLink>
                </motion.div>

                <span className="text-muted mt-3" style={{ fontSize: "0.8rem", letterSpacing: "0.5px" }}>
                  Response time: less than 24 hours
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Clients Section - Redesigned to Orbiting Oval Ring with Left Details Card */}
      <motion.div
        className="container my-5 py-5"
        initial="hidden"
        whileInView="visible"
        variants={staggerContainer}
        viewport={{ once: true }}
      >
        <style>{`
          /* Orbiting Oval Ring */
          .orbit-container {
            position: relative;
            width: 820px;
            height: 460px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .orbiting-ring {
            position: absolute;
            width: 720px;
            height: 380px;
            border: 2px dashed rgba(27, 122, 67, 0.15);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: none;
          }
          
          .rocket-svg {
            animation: rocketLaunch 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            filter: drop-shadow(0 0 6px rgba(14, 165, 233, 0.6));
          }
          .rocket-flame {
            position: absolute;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%) rotate(-45deg) translateY(10px) translateX(10px);
            width: 8px;
            border-radius: 0 0 6px 6px;
            background: linear-gradient(to bottom, #fbbf24, #f97316, transparent);
            animation: flameFlicker 0.5s ease-in-out infinite, trailFade 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
          }
          .rocket-glow {
            position: absolute;
            inset: -6px;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(14,165,233,0.25) 0%, transparent 70%);
            animation: exhaustGlow 2.5s ease-in-out infinite;
          }        .center-brand-orb {
            position: relative;
            width: 150px;
            height: 150px;
            border-radius: 50%;
            background: linear-gradient(135deg, #7f22ec 0%, #1b7a43 100%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
            text-align: center;
            padding: 15px;
            box-shadow: 0 15px 35px rgba(127, 34, 236, 0.35), 0 0 0 8px rgba(27, 122, 67, 0.05);
            z-index: 5;
            border: 2px solid rgba(255, 255, 255, 0.2);
            animation: pulse-brand-orb 4s infinite ease-in-out;
          }

          @keyframes pulse-brand-orb {
            0%, 100% {
              box-shadow: 0 15px 35px rgba(127, 34, 236, 0.3), 0 0 0 8px rgba(27, 122, 67, 0.05);
              transform: scale(1);
            }
            50% {
              box-shadow: 0 15px 45px rgba(127, 34, 236, 0.5), 0 0 0 15px rgba(27, 122, 67, 0.12);
              transform: scale(1.03);
            }
          }

          @keyframes spin-ring {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          
          .orbiting-logo-card {
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.85);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            border: 1px solid rgba(255, 255, 255, 0.7);
            box-shadow: 0 6px 15px rgba(0, 0, 0, 0.04);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px;
            transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            cursor: pointer;
          }
          
          .orbiting-logo-card.active {
            background: #ffffff;
            box-shadow: 0 15px 35px rgba(27, 122, 67, 0.15), 0 0 0 3px #1b7a43;
            border-color: #1b7a43;
            transform: scale(1.15);
          }
          
          .orbiting-logo-card:hover {
            transform: scale(1.2) translateY(-6px);
            background: #ffffff;
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(27, 122, 67, 0.15);
            border-color: rgba(27, 122, 67, 0.25);
          }
          
          .orbiting-logo-card img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transition: transform 0.4s ease;
          }
          
          .orbiting-logo-card:hover img {
            transform: scale(1.05);
          }
          
          /* Mobile styles for rotating oval */
          @media (max-width: 768px) {
            .orbit-container {
              width: 340px;
              height: 260px;
            }
            
            .orbiting-ring {
              width: 280px;
              height: 200px;
            }
            
            .center-brand-orb {
              width: 90px;
              height: 90px;
              padding: 8px;
              box-shadow: 0 8px 20px rgba(127, 34, 236, 0.25);
            }
            
            .center-brand-orb h4 {
              font-size: 0.58rem !important;
              line-height: 1.2;
            }
            
            .orbiting-logo-card {
              padding: 7px;
            }
            
            .orbiting-logo-card.active {
              box-shadow: 0 8px 20px rgba(27, 122, 67, 0.15), 0 0 0 2px #1b7a43;
            }
          }
        `}</style>

        <motion.div className="text-center mb-5" variants={fadeInUp}>
          <span
            style={{
              fontFamily: "'Playball', cursive",
              fontSize: "2.6rem",
              color: "#f7b924",
              display: "block",
              marginBottom: "4px",
              lineHeight: "1.2",
              letterSpacing: "1px"
            }}
          >
            Our Clients
          </span>
          <h2
            className="fw-bold mb-3"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: "800",
              fontSize: "2.8rem",
              color: "#0f2441",
              letterSpacing: "-0.5px",
              lineHeight: "1.2"
            }}
          >
            With Whom We <span style={{ background: "linear-gradient(135deg, #7f22ec 0%, #1b7a43 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>Work</span>
          </h2>
          <div className="mx-auto mb-4" style={{ width: "60px", height: "4px", background: "linear-gradient(90deg, #7f22ec, #1b7a43)", borderRadius: "2px" }}></div>
          <p
            className="mx-auto"
            style={{
              maxWidth: "600px",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: "1.05rem",
              color: "#64748b",
              lineHeight: "1.6"
            }}
          >
            Trusted by industry leaders and innovative businesses across various
            sectors.
          </p>
        </motion.div>

        {(() => {
          const activeAngleDeg = (360 / CLIENTS_DATA.length) * activeClient + rotationAngle;
          const activeAngleRad = (activeAngleDeg * Math.PI) / 180;
          const activeX = rx * Math.cos(activeAngleRad);
          const activeY = ry * Math.sin(activeAngleRad);
          const centerX = isMobile ? 170 : 410;
          const centerY = isMobile ? 130 : 230;

          return (
            <div className="row align-items-center justify-content-center mt-4">
              {/* Left Column: Orbiting Ring (Centered in its area) */}
              <div className="col-12 col-lg-7 col-xl-8 d-flex justify-content-center align-items-center mb-5 mb-lg-0">
                <div className="orbit-container">
                  {/* Center Brand Orb */}
                  <div className="center-brand-orb">
                    <LucideRocket size={24} className="mb-2 text-white animate-bounce" style={{ animationDuration: "3s" }} />
                    <h4 className="m-0 fw-bold" style={{ fontSize: "0.85rem", letterSpacing: "0.5px", fontFamily: "'Outfit', sans-serif" }}>
                      INNOVATIVE SOLUTIONS
                    </h4>
                  </div>

                  {/* Background Static Ellipse Ring */}
                  <div className="orbiting-ring" />

                  {/* Dynamic Connection Line */}
                  <svg
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      top: 0,
                      left: 0,
                      pointerEvents: "none",
                      zIndex: 3
                    }}
                  >
                    <defs>
                      <linearGradient id="activeLineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#7f22ec" stopOpacity="0.8" />
                        <stop offset="100%" stopColor="#1b7a43" stopOpacity="0.8" />
                      </linearGradient>
                      <filter id="lineGlow" x="-20%" y="-20%" width="140%" height="140%">
                        <feGaussianBlur stdDeviation="6" result="blur" />
                        <feComposite in="SourceGraphic" in2="blur" operator="over" />
                      </filter>
                    </defs>
                    <motion.line
                      x1={centerX}
                      y1={centerY}
                      stroke="url(#activeLineGradient)"
                      strokeWidth="3"
                      filter="url(#lineGlow)"
                      strokeDasharray="8, 6"
                      animate={{
                        x2: centerX + activeX,
                        y2: centerY + activeY,
                        strokeDashoffset: [0, -50]
                      }}
                      transition={{
                        x2: { type: "spring", stiffness: 40, damping: 12, mass: 0.8 },
                        y2: { type: "spring", stiffness: 40, damping: 12, mass: 0.8 },
                        strokeDashoffset: { repeat: Infinity, duration: 1.5, ease: "linear" }
                      }}
                    />
                  </svg>

                  {/* Orbiting Logos */}
                  {CLIENTS_DATA.map((logo, index) => {
                    const angleDeg = (360 / CLIENTS_DATA.length) * index + rotationAngle;
                    const angleRad = (angleDeg * Math.PI) / 180;
                    const x = rx * Math.cos(angleRad);
                    const y = ry * Math.sin(angleRad);
                    const isActive = index === activeClient;

                    return (
                      <motion.div
                        key={index}
                        className="orbiting-logo-wrapper"
                        style={{
                          position: "absolute",
                          transform: "translate(-50%, -50%)",
                          width: isMobile ? "44px" : "75px",
                          height: isMobile ? "44px" : "75px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: isActive ? 10 : 2
                        }}
                        animate={{
                          left: `calc(50% + ${x}px)`,
                          top: `calc(50% + ${y}px)`
                        }}
                        transition={{
                          type: "spring",
                          stiffness: 40,
                          damping: 12,
                          mass: 0.8
                        }}
                      >
                        {isActive && (
                          <motion.div
                            className="position-absolute"
                            style={{
                              width: isMobile ? "54px" : "90px",
                              height: isMobile ? "54px" : "90px",
                              borderRadius: "50%",
                              border: "2px solid #1b7a43",
                              zIndex: -1,
                            }}
                            animate={{
                              scale: [1, 1.3, 1],
                              opacity: [0.8, 0, 0.8]
                            }}
                            transition={{
                              duration: 2,
                              repeat: Infinity,
                              ease: "easeInOut"
                            }}
                          />
                        )}
                        <div
                          className={`orbiting-logo-card ${isActive ? 'active' : ''}`}
                          onClick={() => handleClientSelect(index)}
                          style={{
                            width: isMobile ? "44px" : "75px",
                            height: isMobile ? "44px" : "75px"
                          }}
                        >
                          <img src={logo.src} alt={logo.name} />
                        </div>
                      </motion.div>
                    );
                  })}
                </div>
              </div>

              {/* Right Column: Client Detail Card (Centered below orbit on mobile, right on desktop) */}
              <div className="col-12 col-lg-5 col-xl-4">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={activeClient}
                    initial={{ opacity: 0, x: 40, scale: 0.96 }}
                    animate={{ opacity: 1, x: 0, scale: 1 }}
                    exit={{ opacity: 0, x: -20, scale: 0.96 }}
                    transition={{
                      type: "spring",
                      stiffness: 70,
                      damping: 15
                    }}
                    className="p-0"
                    style={{
                      background: "transparent"
                    }}
                  >
                    <div className="d-flex flex-column align-items-start gap-3">
                      {/* Logo Image in details */}
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                          width: isMobile ? "90px" : "130px",
                          height: isMobile ? "90px" : "130px",
                          borderRadius: isMobile ? "16px" : "24px",
                          background: "#ffffff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
                          padding: isMobile ? "12px" : "18px",
                          border: "1px solid rgba(0,0,0,0.02)"
                        }}
                      >
                        <img
                          src={CLIENTS_DATA[activeClient].src}
                          alt={CLIENTS_DATA[activeClient].name}
                          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                        />
                      </div>

                      <div>
                        <span className="text-primary fw-bold text-uppercase" style={{ fontSize: "0.8rem", letterSpacing: "1px", fontFamily: "'Outfit', sans-serif" }}>Selected Client</span>
                        <h3
                          className="fw-bold mt-1 mb-2"
                          style={{
                            fontFamily: "'Outfit', sans-serif",
                            fontSize: "1.6rem",
                            color: "#0f2441",
                            letterSpacing: "-0.5px"
                          }}
                        >
                          {CLIENTS_DATA[activeClient].name}
                        </h3>
                      </div>
                    </div>

                    <p
                      className="text-muted mb-0"
                      style={{
                        fontFamily: "'Outfit', sans-serif",
                        fontSize: "1rem",
                        lineHeight: "1.6",
                        color: "#64748b"
                      }}
                    >
                      {CLIENTS_DATA[activeClient].desc}
                    </p>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          );
        })()}
      </motion.div>

      {/* Testimonials Section - Redesigned to Speech Bubble Layout */}
      <motion.div
        ref={testimonialsRef}
        className="testimonials-section py-5"
        style={{
          background: "linear-gradient(135deg, #f8f9fa 0%, #e2e8f0 100%)",
          position: "relative",
          overflow: "hidden"
        }}
        initial="hidden"
        animate={testimonialsInView ? "visible" : "hidden"}
        variants={staggerContainer}
      >
        {/* Google Fonts Import for Premium Typography */}
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Playball&family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;1,400&display=swap');
          @keyframes pulse-btn {
            0%, 100% {
              box-shadow: 0 4px 12px rgba(247, 185, 36, 0.3), 0 0 0 0 rgba(247, 185, 36, 0.3);
              transform: scale(1);
            }
            50% {
              box-shadow: 0 4px 20px rgba(247, 185, 36, 0.5), 0 0 0 8px rgba(247, 185, 36, 0);
              transform: scale(1.05);
            }
          }
          .swiper-prev-btn-custom,
          .swiper-next-btn-custom {
            animation: pulse-btn 3s infinite ease-in-out;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
          }
          .swiper-prev-btn-custom:hover,
          .swiper-next-btn-custom:hover {
            animation: none !important;
            transform: scale(1.15) translateY(-2px) !important;
            background-color: #ffa000 !important;
            box-shadow: 0 8px 25px rgba(247, 185, 36, 0.5) !important;
          }
          .swiper-prev-btn-custom:active,
          .swiper-next-btn-custom:active {
            transform: scale(0.95) !important;
          }
        `}</style>

        {/* Animated Background Elements */}
        <div className="testimonials-bg-animation">
          {[...Array(12)].map((_, i) => (
            <motion.div
              key={i}
              className="floating-shape"
              animate={{
                x: [0, 50, 0],
                y: [0, -30, 0],
                rotate: [0, 180, 360],
                scale: [1, 1.2, 1],
              }}
              transition={{
                duration: 6 + Math.random() * 4,
                repeat: Infinity,
                delay: Math.random() * 3,
              }}
              style={{
                position: 'absolute',
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                width: `${15 + Math.random() * 25}px`,
                height: `${15 + Math.random() * 25}px`,
                background: `linear-gradient(45deg, rgba(13,110,253,0.1), rgba(36,62,124,0.1))`,
                borderRadius: Math.random() > 0.5 ? '50%' : '20%',
                filter: 'blur(1px)',
              }}
            />
          ))}
        </div>

        <div className="container py-4 position-relative">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <motion.div className="text-center mb-5" variants={fadeInUp}>
                <div className="section-header mb-4">
                  <span
                    style={{
                      fontFamily: "'Playball', cursive",
                      fontSize: "2.6rem",
                      color: "#f7b924",
                      display: "block",
                      marginBottom: "4px",
                      lineHeight: "1.2",
                      letterSpacing: "1px"
                    }}
                  >
                    What Our Team Says
                  </span>
                  <h2
                    className="fw-bold mb-3"
                    style={{
                      color: "#0f2441",
                      fontFamily: "'Outfit', sans-serif",
                      fontWeight: "800",
                      fontSize: "2.8rem",
                      letterSpacing: "-0.5px"
                    }}
                  >
                    Hear From Our Team
                  </h2>
                  <div className="mx-auto mb-4" style={{ width: "80px", height: "4px", background: "linear-gradient(90deg, #ffb300, #ff6f00)", borderRadius: "2px" }}></div>
                  <p
                    className="lead mx-auto"
                    style={{
                      maxWidth: "600px",
                      fontFamily: "'Outfit', sans-serif",
                      fontWeight: "400",
                      fontSize: "1.05rem",
                      color: "#64748b",
                      lineHeight: "1.6"
                    }}
                  >
                    Discover the experiences and growth journeys of our talented team members
                  </p>
                </div>

                {/* Enhanced Tab Navigation */}
                <div className="tab-navigation-wrapper mb-5">
                  <div className="btn-group tab-buttons shadow-sm" role="group">
                    <motion.button
                      type="button"
                      className={`btn tab-btn ${activeTab === 'interns' ? 'active' : ''}`}
                      onClick={() => handleTabChange('interns')}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <i className="bi bi-mortarboard me-2"></i>

                    </motion.button>
                  </div>
                </div>
              </motion.div>

              {/* Speech Bubble Testimonial Carousel */}
              <motion.div variants={fadeInUp}>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={30}
                  pagination={false}
                  navigation={{
                    prevEl: ".swiper-prev-btn-custom",
                    nextEl: ".swiper-next-btn-custom"
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  loop={true}
                  slidesPerView={1}
                  breakpoints={{
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    }
                  }}
                  className="simplified-testimonial-swiper"
                  key={activeTab}
                >
                  {currentTestimonials.map((testimonial, index) => (
                    <SwiperSlide key={testimonial.id}>
                      <motion.div
                        className="d-flex flex-column align-items-start position-relative pt-2 pb-0"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          delay: index * 0.1,
                          duration: 0.6,
                          ease: "easeOut"
                        }}
                        style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}
                      >
                        {/* Dark testimonial text box */}
                        <div
                          className="w-100 p-4 p-md-4"
                          style={{
                            backgroundColor: "#222831",
                            borderRadius: "16px",
                            boxShadow: "0 15px 35px rgba(0, 0, 0, 0.1)",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            border: "1px solid rgba(255, 255, 255, 0.03)"
                          }}
                        >
                          {/* Testimonial Text */}
                          <p
                            className="m-0"
                            style={{
                              fontFamily: "'Plus Jakarta Sans', sans-serif",
                              fontSize: "0.98rem",
                              lineHeight: "1.7",
                              fontStyle: "italic",
                              color: "#cbd5e1",
                              fontWeight: "400"
                            }}
                          >
                            "{testimonial.quote}"
                          </p>

                          {/* Name and Designation */}
                          <div className="mt-3 border-top pt-3" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
                            <h4
                              className="m-0 fw-bold text-white"
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontWeight: "700",
                                fontSize: "1.1rem",
                                letterSpacing: "0.5px"
                              }}
                            >
                              {testimonial.name}
                            </h4>
                            <span
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                color: "#f7b924",
                                fontSize: "0.8rem",
                                fontWeight: "600",
                                letterSpacing: "0.5px"
                              }}
                            >
                              {testimonial.position}
                            </span>
                          </div>
                        </div>

                        {/* Avatar with yellow/orange border and pointing triangle */}
                        <div
                          className="position-relative d-inline-block"
                          style={{
                            marginTop: "-20px",
                            marginLeft: "35px",
                            zIndex: 10
                          }}
                        >
                          {/* Triangle pointing UP */}
                          <div
                            style={{
                              position: "absolute",
                              top: "-6px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              width: 0,
                              height: 0,
                              borderLeft: "8px solid transparent",
                              borderRight: "8px solid transparent",
                              borderBottom: "8px solid #f7b924",
                              zIndex: 11
                            }}
                          />
                          {/* Circular Avatar */}
                          <div
                            className="d-flex align-items-center justify-content-center overflow-hidden"
                            style={{
                              width: "70px",
                              height: "70px",
                              borderRadius: "50%",
                              border: "4px solid #f7b924",
                              background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                              color: "#ffffff",
                              fontSize: "1.2rem",
                              fontWeight: "700",
                              boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
                            }}
                          >
                            {testimonial.image ? (
                              <img
                                src={testimonial.image}
                                alt={testimonial.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover"
                                }}
                              />
                            ) : (
                              testimonial.initials
                            )}
                          </div>
                        </div>
                      </motion.div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* Navigation Chevrons at the Bottom Center */}
                <div className="d-flex justify-content-center gap-3 mt-0">
                  <button
                    className="swiper-prev-btn-custom d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      backgroundColor: "#f7b924",
                      color: "#ffffff",
                      border: "none",
                      boxShadow: "0 4px 12px rgba(247, 185, 36, 0.3)",
                      cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                  </button>
                  <button
                    className="swiper-next-btn-custom d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      backgroundColor: "#f7b924",
                      color: "#ffffff",
                      border: "none",
                      boxShadow: "0 4px 12px rgba(247, 185, 36, 0.3)",
                      cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Original Testimonials CSS */}
      <style jsx>{`
        /* Enhanced Testimonials Section */
        .testimonials-section {
          position: relative;
          min-height: 80vh;
        }

        .testimonials-bg-animation {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: 0;
        }

        /* Section Header Enhancements */
        .gradient-text {
          background: linear-gradient(135deg, #0d6efd, #243e7c);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .underline-decorator {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #0d6efd, #243e7c);
          border-radius: 2px;
        }

        /* Enhanced Tab Navigation */
        .tab-navigation-wrapper {
          display: flex;
          justify-content: center;
        }

        .tab-buttons {
          border-radius: 50px;
          overflow: hidden;
          border: none;
          background: white;
        }

        .tab-btn {
          padding: 12px 28px;
          border: none;
          background: white;
          color: #6c757d;
          font-weight: 500;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .tab-btn:before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #0d6efd, #243e7c);
          transition: left 0.3s ease;
          z-index: -1;
        }

        .tab-btn.active:before,
        .tab-btn:hover:before {
          left: 0;
        }

        .tab-btn.active,
        .tab-btn:hover {
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(13, 110, 253, 0.3);
        }

        .tab-btn .badge {
          background: rgba(255, 255, 255, 0.2);
          font-size: 10px;
          padding: 2px 6px;
        }

        /* Simplified Testimonial Cards */
        .testimonial-card-simplified {
          background: white;
          border-radius: 24px;
          padding: 0;
          height: 400px;
          width: 100%;
          position: relative;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          cursor: pointer;
        }

        .card-bg-gradient {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, 
            rgba(13, 110, 253, 0.02) 0%, 
            rgba(36, 62, 124, 0.02) 100%);
          pointer-events: none;
        }

        .testimonial-card-simplified:hover .card-bg-gradient {
          background: linear-gradient(135deg, 
            rgba(13, 110, 253, 0.05) 0%, 
            rgba(36, 62, 124, 0.05) 100%);
        }

        .quote-icon {
          position: absolute;
          top: -15px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #0d6efd, #243e7c);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: white;
          z-index: 2;
          box-shadow: 0 8px 25px rgba(13, 110, 253, 0.3);
        }

        .card-content {
          padding: 40px 30px 30px;
          height: 100%;
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 1;
        }

        /* Profile Section */
        .profile-section {
          display: flex;
          align-items: center;
          gap: 16px;
          flex-shrink: 0;
        }

        .profile-avatar {
          position: relative;
          flex-shrink: 0;
        }

        .avatar-circle {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #0d6efd, #243e7c);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        .avatar-initials {
          color: white;
          font-size: 18px;
          font-weight: 700;
        }

        .avatar-ring {
          position: absolute;
          top: -5px;
          left: -5px;
          right: -5px;
          bottom: -5px;
          border: 2px solid rgba(13, 110, 253, 0.3);
          border-radius: 50%;
          animation: pulse-ring 2s infinite;
        }

        @keyframes pulse-ring {
          0% { transform: scale(1); opacity: 1; }
          100% { transform: scale(1.2); opacity: 0; }
        }

        .profile-info {
          flex: 1;
          min-width: 0;
        }

        .profile-name {
          font-size: 18px;
          font-weight: 700;
          color: #2c3e50;
          margin: 0 0 6px 0;
          line-height: 1.3;
        }

        .position-badge {
          background: linear-gradient(135deg, rgba(13, 110, 253, 0.1), rgba(36, 62, 124, 0.1));
          color: #0d6efd;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          border: 1px solid rgba(13, 110, 253, 0.2);
        }

        /* Testimonial Text */
        .testimonial-text-container {
          flex: 1;
          margin: 20px 0;
          overflow-y: auto;
        }

        .testimonial-text {
          color: #5a6c7d;
          font-size: 14px;
          line-height: 1.6;
          margin: 0;
          font-style: italic;
          position: relative;
          padding-left: 20px;
        }

        .testimonial-text:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(135deg, #0d6efd, #243e7c);
          border-radius: 2px;
        }

        /* Custom Scrollbar for testimonial text */
        .testimonial-text-container::-webkit-scrollbar {
          width: 4px;
        }

        .testimonial-text-container::-webkit-scrollbar-track {
          background: transparent;
        }

        .testimonial-text-container::-webkit-scrollbar-thumb {
          background: rgba(13, 110, 253, 0.3);
          border-radius: 2px;
        }

        /* Swiper Customizations */
        .simplified-testimonial-swiper {
          padding-bottom: 0px;
        }

        .simplified-testimonial-swiper .swiper-slide {
          height: auto;
          display: flex;
          align-items: stretch;
        }
       

        /* General hover effects */
        .modern-btn:hover {
          transform: translateY(-3px);
        }

        /* Background animations positioning */
        .services-bg-animation,
        .work-bg-animation,
        .stats-bg-animation,
        .cta-bg-animation {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: 1;
        }

        /* Responsive Design */
        @media (max-width: 1200px) {
          .card-content {
            padding: 30px 25px 25px;
          }
          
          .testimonial-card-simplified {
            height: 380px;
          }
        }
@media (max-width: 992px) {
  .feature-item {
    display: none !important;
  }
}
        @media (max-width: 768px) {
          .profile-section {
            flex-direction: column;
            text-align: center;
            gap: 12px;
          }
          
          .card-content {
            padding: 25px 20px 20px;
          }
          
          .testimonial-card-simplified {
            height: 360px;
          }
          
          .profile-name {
            font-size: 16px;
          }
          
          .testimonial-text {
            font-size: 13px;
          }
          
          .tab-btn {
            padding: 10px 20px;
            font-size: 14px;
          }
          
          .quote-icon {
            width: 50px;
            height: 50px;
            font-size: 20px;
            top: -10px;
            right: 15px;
          }
        }

        @media (max-width: 576px) {
          .display-5 {
            font-size: 1.8rem;
          }
          
          .card-content {
            padding: 20px 15px 15px;
          }
          
          .testimonial-card-simplified {
            height: 340px;
          }
          
          .avatar-circle {
            width: 60px;
            height: 60px;
          }
          
          .avatar-initials {
            font-size: 16px;
          }
          
          .profile-name {
            font-size: 15px;
          }
          
          .testimonial-text {
            font-size: 12px;
            padding-left: 15px;
          }
          
          .simplified-testimonial-swiper {
            padding-bottom: 0px;
          }
        }
      `}</style>
    </>
  );
};

export default Home;